/* eslint-disable */
/* tslint:disable */

/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
import {
  UpdateApplicationInput,
  Benefit,
  McdType,
  McdSubtype,
  SlideType,
  NjmmisCheckResult,
} from './globalTypes' // ====================================================
// GraphQL mutation operation: UpdateApplication
// ====================================================

import {deserializeUpdateApplicationInput} from './globalTypes'
import {serializeUpdateApplicationInput} from './globalTypes'
import {UpdateApplicationVariables as UpdateApplicationVariablesOrig} from '../types/UpdateApplication'
import {UpdateApplication as UpdateApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication as UpdateApplication_updateApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication as UpdateApplication_updateApplication_RyanWhiteApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_accountOnDateOfService as UpdateApplication_updateApplication_RyanWhiteApplication_accountOnDateOfServiceOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_benefitOutcomes as UpdateApplication_updateApplication_RyanWhiteApplication_benefitOutcomesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_benefitOutcomes_application as UpdateApplication_updateApplication_RyanWhiteApplication_benefitOutcomes_applicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_benefitOutcomes_person as UpdateApplication_updateApplication_RyanWhiteApplication_benefitOutcomes_personOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_documentFiles as UpdateApplication_updateApplication_RyanWhiteApplication_documentFilesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_documentFiles_documents as UpdateApplication_updateApplication_RyanWhiteApplication_documentFiles_documentsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_documents as UpdateApplication_updateApplication_RyanWhiteApplication_documentsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_documents_application as UpdateApplication_updateApplication_RyanWhiteApplication_documents_applicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_documents_person as UpdateApplication_updateApplication_RyanWhiteApplication_documents_personOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_documents_files as UpdateApplication_updateApplication_RyanWhiteApplication_documents_filesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers as UpdateApplication_updateApplication_RyanWhiteApplication_householdMembersOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person as UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_personOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_documentFiles as UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_documentFilesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_deductions as UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_deductionsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_incomeSources as UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_incomeSourcesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_incomeSources_esignSession as UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_incomeSources_esignSessionOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_incomeSources_esignSession_esignWizards as UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_incomeSources_esignSession_esignWizardsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes as UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application as UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_applicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_SlideApplication as UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_SlideApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication as UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication as UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_phoneNumbers as UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_phoneNumbersOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSession as UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSessionOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards as UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSession_esignWizardsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_assignedTo as UpdateApplication_updateApplication_RyanWhiteApplication_assignedToOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_person as UpdateApplication_updateApplication_RyanWhiteApplication_personOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_person_openHouseholdMemberApplications as UpdateApplication_updateApplication_RyanWhiteApplication_person_openHouseholdMemberApplicationsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications as UpdateApplication_updateApplication_RyanWhiteApplication_person_openApplicationsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_RyanWhiteApplication as UpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_SlideApplication as UpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_SlideApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_CharityCareApplication as UpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_CharityCareApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_MedicaidApplication as UpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_MedicaidApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_person_documentFiles as UpdateApplication_updateApplication_RyanWhiteApplication_person_documentFilesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships as UpdateApplication_updateApplication_RyanWhiteApplication_person_relationshipsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson as UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPersonOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_deductions as UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_deductionsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_incomeSources as UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_incomeSourcesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSession as UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSessionOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards as UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizardsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes as UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application as UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_applicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication as UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication as UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication as UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers as UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbersOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSession as UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSessionOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards as UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizardsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_person_deductions as UpdateApplication_updateApplication_RyanWhiteApplication_person_deductionsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_person_incomeSources as UpdateApplication_updateApplication_RyanWhiteApplication_person_incomeSourcesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_person_incomeSources_esignSession as UpdateApplication_updateApplication_RyanWhiteApplication_person_incomeSources_esignSessionOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_person_incomeSources_esignSession_esignWizards as UpdateApplication_updateApplication_RyanWhiteApplication_person_incomeSources_esignSession_esignWizardsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes as UpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application as UpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_applicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplication as UpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplication as UpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplication as UpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_person_phoneNumbers as UpdateApplication_updateApplication_RyanWhiteApplication_person_phoneNumbersOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_person_phoneNumbers_esignSession as UpdateApplication_updateApplication_RyanWhiteApplication_person_phoneNumbers_esignSessionOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizards as UpdateApplication_updateApplication_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizardsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication as UpdateApplication_updateApplication_SlideApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_accountOnDateOfService as UpdateApplication_updateApplication_SlideApplication_accountOnDateOfServiceOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_benefitOutcomes as UpdateApplication_updateApplication_SlideApplication_benefitOutcomesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_benefitOutcomes_application as UpdateApplication_updateApplication_SlideApplication_benefitOutcomes_applicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_benefitOutcomes_person as UpdateApplication_updateApplication_SlideApplication_benefitOutcomes_personOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_documentFiles as UpdateApplication_updateApplication_SlideApplication_documentFilesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_documentFiles_documents as UpdateApplication_updateApplication_SlideApplication_documentFiles_documentsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_documents as UpdateApplication_updateApplication_SlideApplication_documentsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_documents_application as UpdateApplication_updateApplication_SlideApplication_documents_applicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_documents_person as UpdateApplication_updateApplication_SlideApplication_documents_personOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_documents_files as UpdateApplication_updateApplication_SlideApplication_documents_filesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_householdMembers as UpdateApplication_updateApplication_SlideApplication_householdMembersOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_householdMembers_person as UpdateApplication_updateApplication_SlideApplication_householdMembers_personOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_householdMembers_person_documentFiles as UpdateApplication_updateApplication_SlideApplication_householdMembers_person_documentFilesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_householdMembers_person_deductions as UpdateApplication_updateApplication_SlideApplication_householdMembers_person_deductionsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_householdMembers_person_incomeSources as UpdateApplication_updateApplication_SlideApplication_householdMembers_person_incomeSourcesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_householdMembers_person_incomeSources_esignSession as UpdateApplication_updateApplication_SlideApplication_householdMembers_person_incomeSources_esignSessionOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_householdMembers_person_incomeSources_esignSession_esignWizards as UpdateApplication_updateApplication_SlideApplication_householdMembers_person_incomeSources_esignSession_esignWizardsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes as UpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application as UpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_applicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application_SlideApplication as UpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application_SlideApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication as UpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication as UpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_householdMembers_person_phoneNumbers as UpdateApplication_updateApplication_SlideApplication_householdMembers_person_phoneNumbersOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_householdMembers_person_phoneNumbers_esignSession as UpdateApplication_updateApplication_SlideApplication_householdMembers_person_phoneNumbers_esignSessionOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards as UpdateApplication_updateApplication_SlideApplication_householdMembers_person_phoneNumbers_esignSession_esignWizardsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_assignedTo as UpdateApplication_updateApplication_SlideApplication_assignedToOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_person as UpdateApplication_updateApplication_SlideApplication_personOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_person_openHouseholdMemberApplications as UpdateApplication_updateApplication_SlideApplication_person_openHouseholdMemberApplicationsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_person_openApplications as UpdateApplication_updateApplication_SlideApplication_person_openApplicationsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_person_openApplications_RyanWhiteApplication as UpdateApplication_updateApplication_SlideApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_person_openApplications_SlideApplication as UpdateApplication_updateApplication_SlideApplication_person_openApplications_SlideApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_person_openApplications_CharityCareApplication as UpdateApplication_updateApplication_SlideApplication_person_openApplications_CharityCareApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_person_openApplications_MedicaidApplication as UpdateApplication_updateApplication_SlideApplication_person_openApplications_MedicaidApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_person_documentFiles as UpdateApplication_updateApplication_SlideApplication_person_documentFilesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_person_relationships as UpdateApplication_updateApplication_SlideApplication_person_relationshipsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson as UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPersonOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_deductions as UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_deductionsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_incomeSources as UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_incomeSourcesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_incomeSources_esignSession as UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_incomeSources_esignSessionOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards as UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizardsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes as UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application as UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_applicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication as UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication as UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication as UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_phoneNumbers as UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_phoneNumbersOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSession as UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSessionOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards as UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizardsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_person_deductions as UpdateApplication_updateApplication_SlideApplication_person_deductionsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_person_incomeSources as UpdateApplication_updateApplication_SlideApplication_person_incomeSourcesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_person_incomeSources_esignSession as UpdateApplication_updateApplication_SlideApplication_person_incomeSources_esignSessionOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_person_incomeSources_esignSession_esignWizards as UpdateApplication_updateApplication_SlideApplication_person_incomeSources_esignSession_esignWizardsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes as UpdateApplication_updateApplication_SlideApplication_person_benefitOutcomesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application as UpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_applicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application_SlideApplication as UpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application_SlideApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application_CharityCareApplication as UpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application_MedicaidApplication as UpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_person_phoneNumbers as UpdateApplication_updateApplication_SlideApplication_person_phoneNumbersOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_person_phoneNumbers_esignSession as UpdateApplication_updateApplication_SlideApplication_person_phoneNumbers_esignSessionOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_SlideApplication_person_phoneNumbers_esignSession_esignWizards as UpdateApplication_updateApplication_SlideApplication_person_phoneNumbers_esignSession_esignWizardsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication as UpdateApplication_updateApplication_CharityCareApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_accountOnDateOfService as UpdateApplication_updateApplication_CharityCareApplication_accountOnDateOfServiceOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_benefitOutcomes as UpdateApplication_updateApplication_CharityCareApplication_benefitOutcomesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_benefitOutcomes_application as UpdateApplication_updateApplication_CharityCareApplication_benefitOutcomes_applicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_benefitOutcomes_person as UpdateApplication_updateApplication_CharityCareApplication_benefitOutcomes_personOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_documentFiles as UpdateApplication_updateApplication_CharityCareApplication_documentFilesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_documentFiles_documents as UpdateApplication_updateApplication_CharityCareApplication_documentFiles_documentsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_documents as UpdateApplication_updateApplication_CharityCareApplication_documentsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_documents_application as UpdateApplication_updateApplication_CharityCareApplication_documents_applicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_documents_person as UpdateApplication_updateApplication_CharityCareApplication_documents_personOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_documents_files as UpdateApplication_updateApplication_CharityCareApplication_documents_filesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_householdMembers as UpdateApplication_updateApplication_CharityCareApplication_householdMembersOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person as UpdateApplication_updateApplication_CharityCareApplication_householdMembers_personOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_documentFiles as UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_documentFilesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_deductions as UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_deductionsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_incomeSources as UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_incomeSourcesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_incomeSources_esignSession as UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_incomeSources_esignSessionOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_incomeSources_esignSession_esignWizards as UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_incomeSources_esignSession_esignWizardsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes as UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application as UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_applicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application_SlideApplication as UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application_SlideApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication as UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication as UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_phoneNumbers as UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_phoneNumbersOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_phoneNumbers_esignSession as UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_phoneNumbers_esignSessionOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards as UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_phoneNumbers_esignSession_esignWizardsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_assignedTo as UpdateApplication_updateApplication_CharityCareApplication_assignedToOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_person as UpdateApplication_updateApplication_CharityCareApplication_personOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_person_openHouseholdMemberApplications as UpdateApplication_updateApplication_CharityCareApplication_person_openHouseholdMemberApplicationsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_person_openApplications as UpdateApplication_updateApplication_CharityCareApplication_person_openApplicationsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_person_openApplications_RyanWhiteApplication as UpdateApplication_updateApplication_CharityCareApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_person_openApplications_SlideApplication as UpdateApplication_updateApplication_CharityCareApplication_person_openApplications_SlideApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_person_openApplications_CharityCareApplication as UpdateApplication_updateApplication_CharityCareApplication_person_openApplications_CharityCareApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_person_openApplications_MedicaidApplication as UpdateApplication_updateApplication_CharityCareApplication_person_openApplications_MedicaidApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_person_documentFiles as UpdateApplication_updateApplication_CharityCareApplication_person_documentFilesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_person_relationships as UpdateApplication_updateApplication_CharityCareApplication_person_relationshipsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson as UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPersonOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_deductions as UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_deductionsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_incomeSources as UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_incomeSourcesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSession as UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSessionOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards as UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizardsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes as UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application as UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_applicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication as UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication as UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication as UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_phoneNumbers as UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_phoneNumbersOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSession as UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSessionOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards as UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizardsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_person_deductions as UpdateApplication_updateApplication_CharityCareApplication_person_deductionsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_person_incomeSources as UpdateApplication_updateApplication_CharityCareApplication_person_incomeSourcesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_person_incomeSources_esignSession as UpdateApplication_updateApplication_CharityCareApplication_person_incomeSources_esignSessionOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_person_incomeSources_esignSession_esignWizards as UpdateApplication_updateApplication_CharityCareApplication_person_incomeSources_esignSession_esignWizardsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes as UpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application as UpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_applicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application_SlideApplication as UpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application_SlideApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplication as UpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplication as UpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_person_phoneNumbers as UpdateApplication_updateApplication_CharityCareApplication_person_phoneNumbersOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_person_phoneNumbers_esignSession as UpdateApplication_updateApplication_CharityCareApplication_person_phoneNumbers_esignSessionOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_CharityCareApplication_person_phoneNumbers_esignSession_esignWizards as UpdateApplication_updateApplication_CharityCareApplication_person_phoneNumbers_esignSession_esignWizardsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication as UpdateApplication_updateApplication_MonitorApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact as UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContactOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_deductions as UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_deductionsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_incomeSources as UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_incomeSourcesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_incomeSources_esignSession as UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_incomeSources_esignSessionOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_incomeSources_esignSession_esignWizards as UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_incomeSources_esignSession_esignWizardsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes as UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application as UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_applicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplication as UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplication as UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplication as UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_phoneNumbers as UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_phoneNumbersOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSession as UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSessionOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizards as UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizardsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_accountOnDateOfService as UpdateApplication_updateApplication_MonitorApplication_accountOnDateOfServiceOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_benefitOutcomes as UpdateApplication_updateApplication_MonitorApplication_benefitOutcomesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_benefitOutcomes_application as UpdateApplication_updateApplication_MonitorApplication_benefitOutcomes_applicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_benefitOutcomes_person as UpdateApplication_updateApplication_MonitorApplication_benefitOutcomes_personOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_documentFiles as UpdateApplication_updateApplication_MonitorApplication_documentFilesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_documentFiles_documents as UpdateApplication_updateApplication_MonitorApplication_documentFiles_documentsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_documents as UpdateApplication_updateApplication_MonitorApplication_documentsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_documents_application as UpdateApplication_updateApplication_MonitorApplication_documents_applicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_documents_person as UpdateApplication_updateApplication_MonitorApplication_documents_personOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_documents_files as UpdateApplication_updateApplication_MonitorApplication_documents_filesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_householdMembers as UpdateApplication_updateApplication_MonitorApplication_householdMembersOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_householdMembers_person as UpdateApplication_updateApplication_MonitorApplication_householdMembers_personOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_documentFiles as UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_documentFilesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_deductions as UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_deductionsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_incomeSources as UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_incomeSourcesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_incomeSources_esignSession as UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_incomeSources_esignSessionOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_incomeSources_esignSession_esignWizards as UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_incomeSources_esignSession_esignWizardsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes as UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application as UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_applicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application_SlideApplication as UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application_SlideApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication as UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication as UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_phoneNumbers as UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_phoneNumbersOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_phoneNumbers_esignSession as UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_phoneNumbers_esignSessionOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards as UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_phoneNumbers_esignSession_esignWizardsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_assignedTo as UpdateApplication_updateApplication_MonitorApplication_assignedToOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_person as UpdateApplication_updateApplication_MonitorApplication_personOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_person_openHouseholdMemberApplications as UpdateApplication_updateApplication_MonitorApplication_person_openHouseholdMemberApplicationsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_person_openApplications as UpdateApplication_updateApplication_MonitorApplication_person_openApplicationsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_person_openApplications_RyanWhiteApplication as UpdateApplication_updateApplication_MonitorApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_person_openApplications_SlideApplication as UpdateApplication_updateApplication_MonitorApplication_person_openApplications_SlideApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_person_openApplications_CharityCareApplication as UpdateApplication_updateApplication_MonitorApplication_person_openApplications_CharityCareApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_person_openApplications_MedicaidApplication as UpdateApplication_updateApplication_MonitorApplication_person_openApplications_MedicaidApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_person_documentFiles as UpdateApplication_updateApplication_MonitorApplication_person_documentFilesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_person_relationships as UpdateApplication_updateApplication_MonitorApplication_person_relationshipsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson as UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPersonOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_deductions as UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_deductionsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_incomeSources as UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_incomeSourcesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSession as UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSessionOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards as UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizardsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes as UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application as UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_applicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication as UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication as UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication as UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_phoneNumbers as UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_phoneNumbersOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSession as UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSessionOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards as UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizardsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_person_deductions as UpdateApplication_updateApplication_MonitorApplication_person_deductionsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_person_incomeSources as UpdateApplication_updateApplication_MonitorApplication_person_incomeSourcesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_person_incomeSources_esignSession as UpdateApplication_updateApplication_MonitorApplication_person_incomeSources_esignSessionOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_person_incomeSources_esignSession_esignWizards as UpdateApplication_updateApplication_MonitorApplication_person_incomeSources_esignSession_esignWizardsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes as UpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application as UpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_applicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application_SlideApplication as UpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application_SlideApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application_CharityCareApplication as UpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application_MedicaidApplication as UpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_person_phoneNumbers as UpdateApplication_updateApplication_MonitorApplication_person_phoneNumbersOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_person_phoneNumbers_esignSession as UpdateApplication_updateApplication_MonitorApplication_person_phoneNumbers_esignSessionOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MonitorApplication_person_phoneNumbers_esignSession_esignWizards as UpdateApplication_updateApplication_MonitorApplication_person_phoneNumbers_esignSession_esignWizardsOrig} from '../types/UpdateApplication'
import {deserializeMcdSubtype} from 'graphql/converters'
import {serializeMcdSubtype} from 'graphql/converters'
import {deserializeMcdType} from 'graphql/converters'
import {serializeMcdType} from 'graphql/converters'
import {UpdateApplication_updateApplication_MedicaidApplication as UpdateApplication_updateApplication_MedicaidApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact as UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContactOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_deductions as UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_deductionsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_incomeSources as UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_incomeSourcesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_incomeSources_esignSession as UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_incomeSources_esignSessionOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_incomeSources_esignSession_esignWizards as UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_incomeSources_esignSession_esignWizardsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes as UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application as UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_applicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplication as UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplication as UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplication as UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_phoneNumbers as UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_phoneNumbersOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSession as UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSessionOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizards as UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizardsOrig} from '../types/UpdateApplication'
import {deserializeNjmmisCheckResult} from 'graphql/converters'
import {serializeNjmmisCheckResult} from 'graphql/converters'
import {UpdateApplication_updateApplication_MedicaidApplication_accountOnDateOfService as UpdateApplication_updateApplication_MedicaidApplication_accountOnDateOfServiceOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_benefitOutcomes as UpdateApplication_updateApplication_MedicaidApplication_benefitOutcomesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_benefitOutcomes_application as UpdateApplication_updateApplication_MedicaidApplication_benefitOutcomes_applicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_benefitOutcomes_person as UpdateApplication_updateApplication_MedicaidApplication_benefitOutcomes_personOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_documentFiles as UpdateApplication_updateApplication_MedicaidApplication_documentFilesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_documentFiles_documents as UpdateApplication_updateApplication_MedicaidApplication_documentFiles_documentsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_documents as UpdateApplication_updateApplication_MedicaidApplication_documentsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_documents_application as UpdateApplication_updateApplication_MedicaidApplication_documents_applicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_documents_person as UpdateApplication_updateApplication_MedicaidApplication_documents_personOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_documents_files as UpdateApplication_updateApplication_MedicaidApplication_documents_filesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_householdMembers as UpdateApplication_updateApplication_MedicaidApplication_householdMembersOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person as UpdateApplication_updateApplication_MedicaidApplication_householdMembers_personOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_documentFiles as UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_documentFilesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_deductions as UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_deductionsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_incomeSources as UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_incomeSourcesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_incomeSources_esignSession as UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_incomeSources_esignSessionOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_incomeSources_esignSession_esignWizards as UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_incomeSources_esignSession_esignWizardsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes as UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application as UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_applicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application_SlideApplication as UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application_SlideApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication as UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication as UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_phoneNumbers as UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_phoneNumbersOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_phoneNumbers_esignSession as UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_phoneNumbers_esignSessionOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards as UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_phoneNumbers_esignSession_esignWizardsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_assignedTo as UpdateApplication_updateApplication_MedicaidApplication_assignedToOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_person as UpdateApplication_updateApplication_MedicaidApplication_personOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_person_openHouseholdMemberApplications as UpdateApplication_updateApplication_MedicaidApplication_person_openHouseholdMemberApplicationsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_person_openApplications as UpdateApplication_updateApplication_MedicaidApplication_person_openApplicationsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_person_openApplications_RyanWhiteApplication as UpdateApplication_updateApplication_MedicaidApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_person_openApplications_SlideApplication as UpdateApplication_updateApplication_MedicaidApplication_person_openApplications_SlideApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_person_openApplications_CharityCareApplication as UpdateApplication_updateApplication_MedicaidApplication_person_openApplications_CharityCareApplicationOrig} from '../types/UpdateApplication'
import {BenefitType} from 'utils/benefits'
import {deserializeBenefit} from 'graphql/converters'
import {serializeBenefit} from 'graphql/converters'
import {UpdateApplication_updateApplication_MedicaidApplication_person_openApplications_MedicaidApplication as UpdateApplication_updateApplication_MedicaidApplication_person_openApplications_MedicaidApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_person_documentFiles as UpdateApplication_updateApplication_MedicaidApplication_person_documentFilesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_person_relationships as UpdateApplication_updateApplication_MedicaidApplication_person_relationshipsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson as UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPersonOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_deductions as UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_deductionsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_incomeSources as UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_incomeSourcesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSession as UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSessionOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards as UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizardsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes as UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application as UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_applicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication as UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication as UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication as UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_phoneNumbers as UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_phoneNumbersOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSession as UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSessionOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards as UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizardsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_person_deductions as UpdateApplication_updateApplication_MedicaidApplication_person_deductionsOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_person_incomeSources as UpdateApplication_updateApplication_MedicaidApplication_person_incomeSourcesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_person_incomeSources_esignSession as UpdateApplication_updateApplication_MedicaidApplication_person_incomeSources_esignSessionOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_person_incomeSources_esignSession_esignWizards as UpdateApplication_updateApplication_MedicaidApplication_person_incomeSources_esignSession_esignWizardsOrig} from '../types/UpdateApplication'
import {formatISODate} from 'utils/date'
import {UpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes as UpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomesOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application as UpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_applicationOrig} from '../types/UpdateApplication'
import {deserializeSlideType} from 'graphql/converters'
import {serializeSlideType} from 'graphql/converters'
import {UpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application_SlideApplication as UpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application_SlideApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplication as UpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplication as UpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_person_phoneNumbers as UpdateApplication_updateApplication_MedicaidApplication_person_phoneNumbersOrig} from '../types/UpdateApplication'
import {UpdateApplication_updateApplication_MedicaidApplication_person_phoneNumbers_esignSession as UpdateApplication_updateApplication_MedicaidApplication_person_phoneNumbers_esignSessionOrig} from '../types/UpdateApplication'
import {parseDate} from 'utils/form/fieldTypes'
import formatISO from 'date-fns/formatISO'
import {UpdateApplication_updateApplication_MedicaidApplication_person_phoneNumbers_esignSession_esignWizards as UpdateApplication_updateApplication_MedicaidApplication_person_phoneNumbers_esignSession_esignWizardsOrig} from '../types/UpdateApplication'
export interface UpdateApplication_updateApplication_MedicaidApplication_person_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_person_phoneNumbers_esignSession_esignWizards = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_person_phoneNumbers_esignSession_esignWizardsOrig
): UpdateApplication_updateApplication_MedicaidApplication_person_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_person_phoneNumbers_esignSession_esignWizards = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_person_phoneNumbers_esignSession_esignWizards
): UpdateApplication_updateApplication_MedicaidApplication_person_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface UpdateApplication_updateApplication_MedicaidApplication_person_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: UpdateApplication_updateApplication_MedicaidApplication_person_phoneNumbers_esignSession_esignWizards[]
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_person_phoneNumbers_esignSession = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_person_phoneNumbers_esignSessionOrig
): UpdateApplication_updateApplication_MedicaidApplication_person_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeUpdateApplication_updateApplication_MedicaidApplication_person_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_person_phoneNumbers_esignSession = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_person_phoneNumbers_esignSession
): UpdateApplication_updateApplication_MedicaidApplication_person_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeUpdateApplication_updateApplication_MedicaidApplication_person_phoneNumbers_esignSession_esignWizards
  ),
})
export interface UpdateApplication_updateApplication_MedicaidApplication_person_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: UpdateApplication_updateApplication_MedicaidApplication_person_phoneNumbers_esignSession | null
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_person_phoneNumbers = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_person_phoneNumbersOrig
): UpdateApplication_updateApplication_MedicaidApplication_person_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeUpdateApplication_updateApplication_MedicaidApplication_person_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_person_phoneNumbers = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_person_phoneNumbers
): UpdateApplication_updateApplication_MedicaidApplication_person_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeUpdateApplication_updateApplication_MedicaidApplication_person_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface UpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplication = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplicationOrig
): UpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplication = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplication
): UpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplication = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplicationOrig
): UpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplication = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplication
): UpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application_SlideApplication = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application_SlideApplicationOrig
): UpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application_SlideApplication = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application_SlideApplication
): UpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type UpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application =
  | UpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplication
  | UpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplication
  | UpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application_SlideApplication
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_applicationOrig
): UpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializeUpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeUpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeUpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application'
  )
}
export const serializeUpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application
): UpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializeUpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeUpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeUpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application'
  )
}
export interface UpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: UpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application | null
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomesOrig
): UpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializeUpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes
): UpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializeUpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface UpdateApplication_updateApplication_MedicaidApplication_person_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_person_incomeSources_esignSession_esignWizards = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_person_incomeSources_esignSession_esignWizardsOrig
): UpdateApplication_updateApplication_MedicaidApplication_person_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_person_incomeSources_esignSession_esignWizards = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_person_incomeSources_esignSession_esignWizards
): UpdateApplication_updateApplication_MedicaidApplication_person_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface UpdateApplication_updateApplication_MedicaidApplication_person_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: UpdateApplication_updateApplication_MedicaidApplication_person_incomeSources_esignSession_esignWizards[]
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_person_incomeSources_esignSession = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_person_incomeSources_esignSessionOrig
): UpdateApplication_updateApplication_MedicaidApplication_person_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeUpdateApplication_updateApplication_MedicaidApplication_person_incomeSources_esignSession_esignWizards
  ),
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_person_incomeSources_esignSession = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_person_incomeSources_esignSession
): UpdateApplication_updateApplication_MedicaidApplication_person_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeUpdateApplication_updateApplication_MedicaidApplication_person_incomeSources_esignSession_esignWizards
  ),
})
export interface UpdateApplication_updateApplication_MedicaidApplication_person_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: UpdateApplication_updateApplication_MedicaidApplication_person_incomeSources_esignSession | null
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_person_incomeSources = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_person_incomeSourcesOrig
): UpdateApplication_updateApplication_MedicaidApplication_person_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeUpdateApplication_updateApplication_MedicaidApplication_person_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_person_incomeSources = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_person_incomeSources
): UpdateApplication_updateApplication_MedicaidApplication_person_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeUpdateApplication_updateApplication_MedicaidApplication_person_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface UpdateApplication_updateApplication_MedicaidApplication_person_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_person_deductions = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_person_deductionsOrig
): UpdateApplication_updateApplication_MedicaidApplication_person_deductions => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_person_deductions = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_person_deductions
): UpdateApplication_updateApplication_MedicaidApplication_person_deductionsOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizardsOrig
): UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards
): UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards[]
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSession = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSessionOrig
): UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSession = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSession
): UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards
  ),
})
export interface UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSession | null
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_phoneNumbers = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_phoneNumbersOrig
): UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_phoneNumbers = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_phoneNumbers
): UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplicationOrig
): UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication
): UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplicationOrig
): UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication
): UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplicationOrig
): UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication
): UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application =
  | UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication
  | UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication
  | UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_applicationOrig
): UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application'
  )
}
export const serializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application
): UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application'
  )
}
export interface UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application | null
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomesOrig
): UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes
): UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizardsOrig
): UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards
): UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards[]
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSession = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSessionOrig
): UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards
  ),
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSession = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSession
): UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards
  ),
})
export interface UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSession | null
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_incomeSources = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_incomeSourcesOrig
): UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_incomeSources = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_incomeSources
): UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_deductions = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_deductionsOrig
): UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_deductions => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_deductions = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_deductions
): UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_deductionsOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes[]
  incomeSources: UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_incomeSources[]
  deductions: UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPersonOrig
): UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_deductions
  ),
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson
): UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPersonOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson_deductions
  ),
})
export interface UpdateApplication_updateApplication_MedicaidApplication_person_relationships {
  __typename: 'Relationship'
  id: string
  relationshipType: string | null
  reverseRelationshipType: string | null
  liveTogether: boolean | null
  otherPerson: UpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_person_relationshipsOrig
): UpdateApplication_updateApplication_MedicaidApplication_person_relationships => ({
  ...serialized,
  otherPerson: deserializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson(
    serialized.otherPerson
  ),
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_person_relationships
): UpdateApplication_updateApplication_MedicaidApplication_person_relationshipsOrig => ({
  ...deserialized,
  otherPerson: serializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships_otherPerson(
    deserialized.otherPerson
  ),
})
export interface UpdateApplication_updateApplication_MedicaidApplication_person_documentFiles {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_person_documentFiles = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_person_documentFilesOrig
): UpdateApplication_updateApplication_MedicaidApplication_person_documentFiles => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_person_documentFiles = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_person_documentFiles
): UpdateApplication_updateApplication_MedicaidApplication_person_documentFilesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface UpdateApplication_updateApplication_MedicaidApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_person_openApplications_MedicaidApplication = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_person_openApplications_MedicaidApplicationOrig
): UpdateApplication_updateApplication_MedicaidApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_person_openApplications_MedicaidApplication = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_person_openApplications_MedicaidApplication
): UpdateApplication_updateApplication_MedicaidApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface UpdateApplication_updateApplication_MedicaidApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_person_openApplications_CharityCareApplication = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_person_openApplications_CharityCareApplicationOrig
): UpdateApplication_updateApplication_MedicaidApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_person_openApplications_CharityCareApplication = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_person_openApplications_CharityCareApplication
): UpdateApplication_updateApplication_MedicaidApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface UpdateApplication_updateApplication_MedicaidApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_person_openApplications_SlideApplication = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_person_openApplications_SlideApplicationOrig
): UpdateApplication_updateApplication_MedicaidApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_person_openApplications_SlideApplication = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_person_openApplications_SlideApplication
): UpdateApplication_updateApplication_MedicaidApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface UpdateApplication_updateApplication_MedicaidApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_person_openApplications_RyanWhiteApplication = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_person_openApplications_RyanWhiteApplicationOrig
): UpdateApplication_updateApplication_MedicaidApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_person_openApplications_RyanWhiteApplication
): UpdateApplication_updateApplication_MedicaidApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type UpdateApplication_updateApplication_MedicaidApplication_person_openApplications =
  | UpdateApplication_updateApplication_MedicaidApplication_person_openApplications_MedicaidApplication
  | UpdateApplication_updateApplication_MedicaidApplication_person_openApplications_CharityCareApplication
  | UpdateApplication_updateApplication_MedicaidApplication_person_openApplications_SlideApplication
  | UpdateApplication_updateApplication_MedicaidApplication_person_openApplications_RyanWhiteApplication
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_person_openApplications = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_person_openApplicationsOrig
): UpdateApplication_updateApplication_MedicaidApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializeUpdateApplication_updateApplication_MedicaidApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeUpdateApplication_updateApplication_MedicaidApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeUpdateApplication_updateApplication_MedicaidApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeUpdateApplication_updateApplication_MedicaidApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_MedicaidApplication_person_openApplications'
  )
}
export const serializeUpdateApplication_updateApplication_MedicaidApplication_person_openApplications = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_person_openApplications
): UpdateApplication_updateApplication_MedicaidApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializeUpdateApplication_updateApplication_MedicaidApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeUpdateApplication_updateApplication_MedicaidApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeUpdateApplication_updateApplication_MedicaidApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeUpdateApplication_updateApplication_MedicaidApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_MedicaidApplication_person_openApplications'
  )
}
export interface UpdateApplication_updateApplication_MedicaidApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_person_openHouseholdMemberApplications = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_person_openHouseholdMemberApplicationsOrig
): UpdateApplication_updateApplication_MedicaidApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_person_openHouseholdMemberApplications = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_person_openHouseholdMemberApplications
): UpdateApplication_updateApplication_MedicaidApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface UpdateApplication_updateApplication_MedicaidApplication_person {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: UpdateApplication_updateApplication_MedicaidApplication_person_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: UpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes[]
  incomeSources: UpdateApplication_updateApplication_MedicaidApplication_person_incomeSources[]
  deductions: UpdateApplication_updateApplication_MedicaidApplication_person_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
  relationships: UpdateApplication_updateApplication_MedicaidApplication_person_relationships[]
  documentFiles: UpdateApplication_updateApplication_MedicaidApplication_person_documentFiles[]
  openApplications: UpdateApplication_updateApplication_MedicaidApplication_person_openApplications[]
  openHouseholdMemberApplications: UpdateApplication_updateApplication_MedicaidApplication_person_openHouseholdMemberApplications[]
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_person = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_personOrig
): UpdateApplication_updateApplication_MedicaidApplication_person => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeUpdateApplication_updateApplication_MedicaidApplication_person_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeUpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeUpdateApplication_updateApplication_MedicaidApplication_person_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeUpdateApplication_updateApplication_MedicaidApplication_person_deductions
  ),
  relationships: serialized.relationships.map(
    deserializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships
  ),
  documentFiles: serialized.documentFiles.map(
    deserializeUpdateApplication_updateApplication_MedicaidApplication_person_documentFiles
  ),
  openApplications: serialized.openApplications.map(
    deserializeUpdateApplication_updateApplication_MedicaidApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializeUpdateApplication_updateApplication_MedicaidApplication_person_openHouseholdMemberApplications
  ),
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_person = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_person
): UpdateApplication_updateApplication_MedicaidApplication_personOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeUpdateApplication_updateApplication_MedicaidApplication_person_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeUpdateApplication_updateApplication_MedicaidApplication_person_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeUpdateApplication_updateApplication_MedicaidApplication_person_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeUpdateApplication_updateApplication_MedicaidApplication_person_deductions
  ),
  relationships: deserialized.relationships.map(
    serializeUpdateApplication_updateApplication_MedicaidApplication_person_relationships
  ),
  documentFiles: deserialized.documentFiles.map(
    serializeUpdateApplication_updateApplication_MedicaidApplication_person_documentFiles
  ),
  openApplications: deserialized.openApplications.map(
    serializeUpdateApplication_updateApplication_MedicaidApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializeUpdateApplication_updateApplication_MedicaidApplication_person_openHouseholdMemberApplications
  ),
})
export interface UpdateApplication_updateApplication_MedicaidApplication_assignedTo {
  __typename: 'User'
  id: string
  email: string
  name: string | null
  isCurrentUser: boolean
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_assignedTo = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_assignedToOrig
): UpdateApplication_updateApplication_MedicaidApplication_assignedTo => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_assignedTo = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_assignedTo
): UpdateApplication_updateApplication_MedicaidApplication_assignedToOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_phoneNumbers_esignSession_esignWizardsOrig
): UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards
): UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards[]
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_phoneNumbers_esignSession = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_phoneNumbers_esignSessionOrig
): UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_phoneNumbers_esignSession = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_phoneNumbers_esignSession
): UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards
  ),
})
export interface UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_phoneNumbers_esignSession | null
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_phoneNumbers = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_phoneNumbersOrig
): UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_phoneNumbers = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_phoneNumbers
): UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplicationOrig
): UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication
): UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplicationOrig
): UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication
): UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application_SlideApplication = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application_SlideApplicationOrig
): UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application_SlideApplication = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application_SlideApplication
): UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application =
  | UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication
  | UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication
  | UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application_SlideApplication
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_applicationOrig
): UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application'
  )
}
export const serializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application
): UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application'
  )
}
export interface UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application | null
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomesOrig
): UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes
): UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_incomeSources_esignSession_esignWizards = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_incomeSources_esignSession_esignWizardsOrig
): UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_incomeSources_esignSession_esignWizards = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_incomeSources_esignSession_esignWizards
): UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_incomeSources_esignSession_esignWizards[]
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_incomeSources_esignSession = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_incomeSources_esignSessionOrig
): UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_incomeSources_esignSession_esignWizards
  ),
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_incomeSources_esignSession = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_incomeSources_esignSession
): UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_incomeSources_esignSession_esignWizards
  ),
})
export interface UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_incomeSources_esignSession | null
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_incomeSources = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_incomeSourcesOrig
): UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_incomeSources = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_incomeSources
): UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_deductions = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_deductionsOrig
): UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_deductions => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_deductions = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_deductions
): UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_deductionsOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_documentFiles {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_documentFiles = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_documentFilesOrig
): UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_documentFiles => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_documentFiles = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_documentFiles
): UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_documentFilesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes[]
  incomeSources: UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_incomeSources[]
  deductions: UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
  documentFiles: UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_documentFiles[]
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_householdMembers_personOrig
): UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_deductions
  ),
  documentFiles: serialized.documentFiles.map(
    deserializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_documentFiles
  ),
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person
): UpdateApplication_updateApplication_MedicaidApplication_householdMembers_personOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_deductions
  ),
  documentFiles: deserialized.documentFiles.map(
    serializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person_documentFiles
  ),
})
export interface UpdateApplication_updateApplication_MedicaidApplication_householdMembers {
  __typename: 'ApplicationHouseholdMember'
  id: string
  wantsCoverage: boolean | null
  person: UpdateApplication_updateApplication_MedicaidApplication_householdMembers_person
  createdAt: Date
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_householdMembersOrig
): UpdateApplication_updateApplication_MedicaidApplication_householdMembers => ({
  ...serialized,
  person: deserializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person(
    serialized.person
  ),
  createdAt: parseDate(serialized.createdAt),
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_householdMembers
): UpdateApplication_updateApplication_MedicaidApplication_householdMembersOrig => ({
  ...deserialized,
  person: serializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers_person(
    deserialized.person
  ),
  createdAt: formatISO(deserialized.createdAt),
})
export interface UpdateApplication_updateApplication_MedicaidApplication_documents_files {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_documents_files = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_documents_filesOrig
): UpdateApplication_updateApplication_MedicaidApplication_documents_files => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_documents_files = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_documents_files
): UpdateApplication_updateApplication_MedicaidApplication_documents_filesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface UpdateApplication_updateApplication_MedicaidApplication_documents_person {
  __typename: 'Person'
  id: string
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_documents_person = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_documents_personOrig
): UpdateApplication_updateApplication_MedicaidApplication_documents_person => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_documents_person = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_documents_person
): UpdateApplication_updateApplication_MedicaidApplication_documents_personOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_MedicaidApplication_documents_application {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_documents_application = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_documents_applicationOrig
): UpdateApplication_updateApplication_MedicaidApplication_documents_application => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_documents_application = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_documents_application
): UpdateApplication_updateApplication_MedicaidApplication_documents_applicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_MedicaidApplication_documents {
  __typename: 'Document'
  id: string
  documentType: string
  complete: boolean | null
  files: UpdateApplication_updateApplication_MedicaidApplication_documents_files[]
  updatedAt: Date
  notes: string | null
  person: UpdateApplication_updateApplication_MedicaidApplication_documents_person | null
  application: UpdateApplication_updateApplication_MedicaidApplication_documents_application
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_documents = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_documentsOrig
): UpdateApplication_updateApplication_MedicaidApplication_documents => ({
  ...serialized,
  files: serialized.files.map(
    deserializeUpdateApplication_updateApplication_MedicaidApplication_documents_files
  ),
  updatedAt: parseDate(serialized.updatedAt),
  person:
    serialized.person != null
      ? deserializeUpdateApplication_updateApplication_MedicaidApplication_documents_person(
          serialized.person
        )
      : serialized.person,
  application: deserializeUpdateApplication_updateApplication_MedicaidApplication_documents_application(
    serialized.application
  ),
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_documents = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_documents
): UpdateApplication_updateApplication_MedicaidApplication_documentsOrig => ({
  ...deserialized,
  files: deserialized.files.map(
    serializeUpdateApplication_updateApplication_MedicaidApplication_documents_files
  ),
  updatedAt: formatISO(deserialized.updatedAt),
  person:
    deserialized.person != null
      ? serializeUpdateApplication_updateApplication_MedicaidApplication_documents_person(
          deserialized.person
        )
      : deserialized.person,
  application: serializeUpdateApplication_updateApplication_MedicaidApplication_documents_application(
    deserialized.application
  ),
})
export interface UpdateApplication_updateApplication_MedicaidApplication_documentFiles_documents {
  __typename: 'Document'
  id: string
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_documentFiles_documents = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_documentFiles_documentsOrig
): UpdateApplication_updateApplication_MedicaidApplication_documentFiles_documents => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_documentFiles_documents = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_documentFiles_documents
): UpdateApplication_updateApplication_MedicaidApplication_documentFiles_documentsOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_MedicaidApplication_documentFiles {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
  documents: UpdateApplication_updateApplication_MedicaidApplication_documentFiles_documents[]
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_documentFiles = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_documentFilesOrig
): UpdateApplication_updateApplication_MedicaidApplication_documentFiles => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
  documents: serialized.documents.map(
    deserializeUpdateApplication_updateApplication_MedicaidApplication_documentFiles_documents
  ),
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_documentFiles = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_documentFiles
): UpdateApplication_updateApplication_MedicaidApplication_documentFilesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
  documents: deserialized.documents.map(
    serializeUpdateApplication_updateApplication_MedicaidApplication_documentFiles_documents
  ),
})
export interface UpdateApplication_updateApplication_MedicaidApplication_benefitOutcomes_person {
  __typename: 'Person'
  id: string
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_benefitOutcomes_person = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_benefitOutcomes_personOrig
): UpdateApplication_updateApplication_MedicaidApplication_benefitOutcomes_person => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_benefitOutcomes_person = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_benefitOutcomes_person
): UpdateApplication_updateApplication_MedicaidApplication_benefitOutcomes_personOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_MedicaidApplication_benefitOutcomes_application {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_benefitOutcomes_application = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_benefitOutcomes_applicationOrig
): UpdateApplication_updateApplication_MedicaidApplication_benefitOutcomes_application => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_benefitOutcomes_application = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_benefitOutcomes_application
): UpdateApplication_updateApplication_MedicaidApplication_benefitOutcomes_applicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_MedicaidApplication_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  person: UpdateApplication_updateApplication_MedicaidApplication_benefitOutcomes_person
  application: UpdateApplication_updateApplication_MedicaidApplication_benefitOutcomes_application | null
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_benefitOutcomes = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_benefitOutcomesOrig
): UpdateApplication_updateApplication_MedicaidApplication_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  person: deserializeUpdateApplication_updateApplication_MedicaidApplication_benefitOutcomes_person(
    serialized.person
  ),
  application:
    serialized.application != null
      ? deserializeUpdateApplication_updateApplication_MedicaidApplication_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_benefitOutcomes = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_benefitOutcomes
): UpdateApplication_updateApplication_MedicaidApplication_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  person: serializeUpdateApplication_updateApplication_MedicaidApplication_benefitOutcomes_person(
    deserialized.person
  ),
  application:
    deserialized.application != null
      ? serializeUpdateApplication_updateApplication_MedicaidApplication_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface UpdateApplication_updateApplication_MedicaidApplication_accountOnDateOfService {
  __typename: 'Account'
  id: string
  hospitalAccountId: string | null
  dateOfService: Date
  timeOfService: string | null
  serviceTimeZone: string
  facility: string
  department: string
  location: string | null
  insuranceType: string
  status: string
  createdAt: Date
  updatedAt: Date
  notes: string | null
  accountAmount: number | null
  njmmisCheck: string | null
  previousInsurance: string | null
  invoiceMonth: string | null
  invoiceYear: string | null
  dischargeDate: Date | null
  isScheduled: boolean
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_accountOnDateOfService = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_accountOnDateOfServiceOrig
): UpdateApplication_updateApplication_MedicaidApplication_accountOnDateOfService => ({
  ...serialized,
  dateOfService: parseDate(serialized.dateOfService),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  njmmisCheck:
    serialized.njmmisCheck != null
      ? deserializeNjmmisCheckResult(serialized.njmmisCheck)
      : serialized.njmmisCheck,
  dischargeDate:
    serialized.dischargeDate != null
      ? parseDate(serialized.dischargeDate)
      : serialized.dischargeDate,
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_accountOnDateOfService = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_accountOnDateOfService
): UpdateApplication_updateApplication_MedicaidApplication_accountOnDateOfServiceOrig => ({
  ...deserialized,
  dateOfService: formatISODate(deserialized.dateOfService),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  njmmisCheck:
    deserialized.njmmisCheck != null
      ? serializeNjmmisCheckResult(deserialized.njmmisCheck)
      : deserialized.njmmisCheck,
  dischargeDate:
    deserialized.dischargeDate != null
      ? formatISODate(deserialized.dischargeDate)
      : deserialized.dischargeDate,
})
export interface UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizards = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizardsOrig
): UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizards = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizards
): UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizards[]
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSession = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSessionOrig
): UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSession = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSession
): UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizards
  ),
})
export interface UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSession | null
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_phoneNumbers = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_phoneNumbersOrig
): UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_phoneNumbers = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_phoneNumbers
): UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplication = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplicationOrig
): UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplication = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplication
): UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplication = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplicationOrig
): UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplication = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplication
): UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplication = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplicationOrig
): UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplication = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplication
): UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application =
  | UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplication
  | UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplication
  | UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplication
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_applicationOrig
): UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application'
  )
}
export const serializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application
): UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application'
  )
}
export interface UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application | null
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomesOrig
): UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes
): UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_incomeSources_esignSession_esignWizards = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_incomeSources_esignSession_esignWizardsOrig
): UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_incomeSources_esignSession_esignWizards = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_incomeSources_esignSession_esignWizards
): UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_incomeSources_esignSession_esignWizards[]
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_incomeSources_esignSession = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_incomeSources_esignSessionOrig
): UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_incomeSources_esignSession_esignWizards
  ),
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_incomeSources_esignSession = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_incomeSources_esignSession
): UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_incomeSources_esignSession_esignWizards
  ),
})
export interface UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_incomeSources_esignSession | null
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_incomeSources = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_incomeSourcesOrig
): UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_incomeSources = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_incomeSources
): UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_deductions = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_deductionsOrig
): UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_deductions => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_deductions = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_deductions
): UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_deductionsOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes[]
  incomeSources: UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_incomeSources[]
  deductions: UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact = (
  serialized: UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContactOrig
): UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_deductions
  ),
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact
): UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContactOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact_deductions
  ),
})
export interface UpdateApplication_updateApplication_MedicaidApplication {
  __typename: 'MedicaidApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  person: UpdateApplication_updateApplication_MedicaidApplication_person
  assignedTo: UpdateApplication_updateApplication_MedicaidApplication_assignedTo | null
  householdMembers: UpdateApplication_updateApplication_MedicaidApplication_householdMembers[]
  documents: UpdateApplication_updateApplication_MedicaidApplication_documents[]
  documentFiles: UpdateApplication_updateApplication_MedicaidApplication_documentFiles[]
  benefitOutcomes: UpdateApplication_updateApplication_MedicaidApplication_benefitOutcomes[]
  accountOnDateOfService: UpdateApplication_updateApplication_MedicaidApplication_accountOnDateOfService | null
  submitDate: Date | null
  submitMethod: string | null
  location: string | null
  countyName: string | null
  confirmationNumber: string | null
  policyId: string | null
  notes: string | null
  initialDateOfService: Date | null
  mcdType: string
  mcdSubtype: string | null
  primaryPointOfContact: UpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact | null
}
export const deserializeUpdateApplication_updateApplication_MedicaidApplication = (
  serialized: UpdateApplication_updateApplication_MedicaidApplicationOrig
): UpdateApplication_updateApplication_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  person: deserializeUpdateApplication_updateApplication_MedicaidApplication_person(
    serialized.person
  ),
  assignedTo:
    serialized.assignedTo != null
      ? deserializeUpdateApplication_updateApplication_MedicaidApplication_assignedTo(
          serialized.assignedTo
        )
      : serialized.assignedTo,
  householdMembers: serialized.householdMembers.map(
    deserializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers
  ),
  documents: serialized.documents.map(
    deserializeUpdateApplication_updateApplication_MedicaidApplication_documents
  ),
  documentFiles: serialized.documentFiles.map(
    deserializeUpdateApplication_updateApplication_MedicaidApplication_documentFiles
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeUpdateApplication_updateApplication_MedicaidApplication_benefitOutcomes
  ),
  accountOnDateOfService:
    serialized.accountOnDateOfService != null
      ? deserializeUpdateApplication_updateApplication_MedicaidApplication_accountOnDateOfService(
          serialized.accountOnDateOfService
        )
      : serialized.accountOnDateOfService,
  submitDate:
    serialized.submitDate != null
      ? parseDate(serialized.submitDate)
      : serialized.submitDate,
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  mcdType: deserializeMcdType(serialized.mcdType),
  mcdSubtype:
    serialized.mcdSubtype != null
      ? deserializeMcdSubtype(serialized.mcdSubtype)
      : serialized.mcdSubtype,
  primaryPointOfContact:
    serialized.primaryPointOfContact != null
      ? deserializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact(
          serialized.primaryPointOfContact
        )
      : serialized.primaryPointOfContact,
})
export const serializeUpdateApplication_updateApplication_MedicaidApplication = (
  deserialized: UpdateApplication_updateApplication_MedicaidApplication
): UpdateApplication_updateApplication_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  person: serializeUpdateApplication_updateApplication_MedicaidApplication_person(
    deserialized.person
  ),
  assignedTo:
    deserialized.assignedTo != null
      ? serializeUpdateApplication_updateApplication_MedicaidApplication_assignedTo(
          deserialized.assignedTo
        )
      : deserialized.assignedTo,
  householdMembers: deserialized.householdMembers.map(
    serializeUpdateApplication_updateApplication_MedicaidApplication_householdMembers
  ),
  documents: deserialized.documents.map(
    serializeUpdateApplication_updateApplication_MedicaidApplication_documents
  ),
  documentFiles: deserialized.documentFiles.map(
    serializeUpdateApplication_updateApplication_MedicaidApplication_documentFiles
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeUpdateApplication_updateApplication_MedicaidApplication_benefitOutcomes
  ),
  accountOnDateOfService:
    deserialized.accountOnDateOfService != null
      ? serializeUpdateApplication_updateApplication_MedicaidApplication_accountOnDateOfService(
          deserialized.accountOnDateOfService
        )
      : deserialized.accountOnDateOfService,
  submitDate:
    deserialized.submitDate != null
      ? formatISODate(deserialized.submitDate)
      : deserialized.submitDate,
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  mcdType: serializeMcdType(deserialized.mcdType),
  mcdSubtype:
    deserialized.mcdSubtype != null
      ? serializeMcdSubtype(deserialized.mcdSubtype)
      : deserialized.mcdSubtype,
  primaryPointOfContact:
    deserialized.primaryPointOfContact != null
      ? serializeUpdateApplication_updateApplication_MedicaidApplication_primaryPointOfContact(
          deserialized.primaryPointOfContact
        )
      : deserialized.primaryPointOfContact,
})
export interface UpdateApplication_updateApplication_MonitorApplication_person_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_person_phoneNumbers_esignSession_esignWizards = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_person_phoneNumbers_esignSession_esignWizardsOrig
): UpdateApplication_updateApplication_MonitorApplication_person_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_person_phoneNumbers_esignSession_esignWizards = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_person_phoneNumbers_esignSession_esignWizards
): UpdateApplication_updateApplication_MonitorApplication_person_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface UpdateApplication_updateApplication_MonitorApplication_person_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: UpdateApplication_updateApplication_MonitorApplication_person_phoneNumbers_esignSession_esignWizards[]
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_person_phoneNumbers_esignSession = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_person_phoneNumbers_esignSessionOrig
): UpdateApplication_updateApplication_MonitorApplication_person_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeUpdateApplication_updateApplication_MonitorApplication_person_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_person_phoneNumbers_esignSession = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_person_phoneNumbers_esignSession
): UpdateApplication_updateApplication_MonitorApplication_person_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeUpdateApplication_updateApplication_MonitorApplication_person_phoneNumbers_esignSession_esignWizards
  ),
})
export interface UpdateApplication_updateApplication_MonitorApplication_person_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: UpdateApplication_updateApplication_MonitorApplication_person_phoneNumbers_esignSession | null
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_person_phoneNumbers = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_person_phoneNumbersOrig
): UpdateApplication_updateApplication_MonitorApplication_person_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeUpdateApplication_updateApplication_MonitorApplication_person_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_person_phoneNumbers = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_person_phoneNumbers
): UpdateApplication_updateApplication_MonitorApplication_person_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeUpdateApplication_updateApplication_MonitorApplication_person_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface UpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application_MedicaidApplication = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application_MedicaidApplicationOrig
): UpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application_MedicaidApplication = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application_MedicaidApplication
): UpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application_CharityCareApplication = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application_CharityCareApplicationOrig
): UpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application_CharityCareApplication = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application_CharityCareApplication
): UpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application_SlideApplication = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application_SlideApplicationOrig
): UpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application_SlideApplication = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application_SlideApplication
): UpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type UpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application =
  | UpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application_MedicaidApplication
  | UpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application_CharityCareApplication
  | UpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application_SlideApplication
export const deserializeUpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_applicationOrig
): UpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializeUpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeUpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeUpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application'
  )
}
export const serializeUpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application
): UpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializeUpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeUpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeUpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application'
  )
}
export interface UpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: UpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application | null
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomesOrig
): UpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializeUpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes
): UpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializeUpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface UpdateApplication_updateApplication_MonitorApplication_person_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_person_incomeSources_esignSession_esignWizards = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_person_incomeSources_esignSession_esignWizardsOrig
): UpdateApplication_updateApplication_MonitorApplication_person_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_person_incomeSources_esignSession_esignWizards = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_person_incomeSources_esignSession_esignWizards
): UpdateApplication_updateApplication_MonitorApplication_person_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface UpdateApplication_updateApplication_MonitorApplication_person_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: UpdateApplication_updateApplication_MonitorApplication_person_incomeSources_esignSession_esignWizards[]
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_person_incomeSources_esignSession = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_person_incomeSources_esignSessionOrig
): UpdateApplication_updateApplication_MonitorApplication_person_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeUpdateApplication_updateApplication_MonitorApplication_person_incomeSources_esignSession_esignWizards
  ),
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_person_incomeSources_esignSession = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_person_incomeSources_esignSession
): UpdateApplication_updateApplication_MonitorApplication_person_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeUpdateApplication_updateApplication_MonitorApplication_person_incomeSources_esignSession_esignWizards
  ),
})
export interface UpdateApplication_updateApplication_MonitorApplication_person_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: UpdateApplication_updateApplication_MonitorApplication_person_incomeSources_esignSession | null
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_person_incomeSources = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_person_incomeSourcesOrig
): UpdateApplication_updateApplication_MonitorApplication_person_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeUpdateApplication_updateApplication_MonitorApplication_person_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_person_incomeSources = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_person_incomeSources
): UpdateApplication_updateApplication_MonitorApplication_person_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeUpdateApplication_updateApplication_MonitorApplication_person_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface UpdateApplication_updateApplication_MonitorApplication_person_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_person_deductions = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_person_deductionsOrig
): UpdateApplication_updateApplication_MonitorApplication_person_deductions => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_person_deductions = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_person_deductions
): UpdateApplication_updateApplication_MonitorApplication_person_deductionsOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizardsOrig
): UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards
): UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards[]
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSession = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSessionOrig
): UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSession = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSession
): UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards
  ),
})
export interface UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSession | null
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_phoneNumbers = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_phoneNumbersOrig
): UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_phoneNumbers = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_phoneNumbers
): UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplicationOrig
): UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication
): UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplicationOrig
): UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication
): UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplicationOrig
): UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication
): UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application =
  | UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication
  | UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication
  | UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication
export const deserializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_applicationOrig
): UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application'
  )
}
export const serializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application
): UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application'
  )
}
export interface UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application | null
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomesOrig
): UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes
): UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizardsOrig
): UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards
): UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards[]
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSession = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSessionOrig
): UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards
  ),
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSession = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSession
): UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards
  ),
})
export interface UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSession | null
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_incomeSources = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_incomeSourcesOrig
): UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_incomeSources = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_incomeSources
): UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_deductions = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_deductionsOrig
): UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_deductions => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_deductions = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_deductions
): UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_deductionsOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes[]
  incomeSources: UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_incomeSources[]
  deductions: UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPersonOrig
): UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_deductions
  ),
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson
): UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPersonOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson_deductions
  ),
})
export interface UpdateApplication_updateApplication_MonitorApplication_person_relationships {
  __typename: 'Relationship'
  id: string
  relationshipType: string | null
  reverseRelationshipType: string | null
  liveTogether: boolean | null
  otherPerson: UpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_person_relationships = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_person_relationshipsOrig
): UpdateApplication_updateApplication_MonitorApplication_person_relationships => ({
  ...serialized,
  otherPerson: deserializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson(
    serialized.otherPerson
  ),
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_person_relationships = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_person_relationships
): UpdateApplication_updateApplication_MonitorApplication_person_relationshipsOrig => ({
  ...deserialized,
  otherPerson: serializeUpdateApplication_updateApplication_MonitorApplication_person_relationships_otherPerson(
    deserialized.otherPerson
  ),
})
export interface UpdateApplication_updateApplication_MonitorApplication_person_documentFiles {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_person_documentFiles = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_person_documentFilesOrig
): UpdateApplication_updateApplication_MonitorApplication_person_documentFiles => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_person_documentFiles = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_person_documentFiles
): UpdateApplication_updateApplication_MonitorApplication_person_documentFilesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface UpdateApplication_updateApplication_MonitorApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_person_openApplications_MedicaidApplication = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_person_openApplications_MedicaidApplicationOrig
): UpdateApplication_updateApplication_MonitorApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_person_openApplications_MedicaidApplication = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_person_openApplications_MedicaidApplication
): UpdateApplication_updateApplication_MonitorApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface UpdateApplication_updateApplication_MonitorApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_person_openApplications_CharityCareApplication = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_person_openApplications_CharityCareApplicationOrig
): UpdateApplication_updateApplication_MonitorApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_person_openApplications_CharityCareApplication = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_person_openApplications_CharityCareApplication
): UpdateApplication_updateApplication_MonitorApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface UpdateApplication_updateApplication_MonitorApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_person_openApplications_SlideApplication = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_person_openApplications_SlideApplicationOrig
): UpdateApplication_updateApplication_MonitorApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_person_openApplications_SlideApplication = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_person_openApplications_SlideApplication
): UpdateApplication_updateApplication_MonitorApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface UpdateApplication_updateApplication_MonitorApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_person_openApplications_RyanWhiteApplication = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_person_openApplications_RyanWhiteApplicationOrig
): UpdateApplication_updateApplication_MonitorApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_person_openApplications_RyanWhiteApplication
): UpdateApplication_updateApplication_MonitorApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type UpdateApplication_updateApplication_MonitorApplication_person_openApplications =
  | UpdateApplication_updateApplication_MonitorApplication_person_openApplications_MedicaidApplication
  | UpdateApplication_updateApplication_MonitorApplication_person_openApplications_CharityCareApplication
  | UpdateApplication_updateApplication_MonitorApplication_person_openApplications_SlideApplication
  | UpdateApplication_updateApplication_MonitorApplication_person_openApplications_RyanWhiteApplication
export const deserializeUpdateApplication_updateApplication_MonitorApplication_person_openApplications = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_person_openApplicationsOrig
): UpdateApplication_updateApplication_MonitorApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializeUpdateApplication_updateApplication_MonitorApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeUpdateApplication_updateApplication_MonitorApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeUpdateApplication_updateApplication_MonitorApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeUpdateApplication_updateApplication_MonitorApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_MonitorApplication_person_openApplications'
  )
}
export const serializeUpdateApplication_updateApplication_MonitorApplication_person_openApplications = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_person_openApplications
): UpdateApplication_updateApplication_MonitorApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializeUpdateApplication_updateApplication_MonitorApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeUpdateApplication_updateApplication_MonitorApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeUpdateApplication_updateApplication_MonitorApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeUpdateApplication_updateApplication_MonitorApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_MonitorApplication_person_openApplications'
  )
}
export interface UpdateApplication_updateApplication_MonitorApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_person_openHouseholdMemberApplications = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_person_openHouseholdMemberApplicationsOrig
): UpdateApplication_updateApplication_MonitorApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_person_openHouseholdMemberApplications = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_person_openHouseholdMemberApplications
): UpdateApplication_updateApplication_MonitorApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface UpdateApplication_updateApplication_MonitorApplication_person {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: UpdateApplication_updateApplication_MonitorApplication_person_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: UpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes[]
  incomeSources: UpdateApplication_updateApplication_MonitorApplication_person_incomeSources[]
  deductions: UpdateApplication_updateApplication_MonitorApplication_person_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
  relationships: UpdateApplication_updateApplication_MonitorApplication_person_relationships[]
  documentFiles: UpdateApplication_updateApplication_MonitorApplication_person_documentFiles[]
  openApplications: UpdateApplication_updateApplication_MonitorApplication_person_openApplications[]
  openHouseholdMemberApplications: UpdateApplication_updateApplication_MonitorApplication_person_openHouseholdMemberApplications[]
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_person = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_personOrig
): UpdateApplication_updateApplication_MonitorApplication_person => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeUpdateApplication_updateApplication_MonitorApplication_person_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeUpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeUpdateApplication_updateApplication_MonitorApplication_person_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeUpdateApplication_updateApplication_MonitorApplication_person_deductions
  ),
  relationships: serialized.relationships.map(
    deserializeUpdateApplication_updateApplication_MonitorApplication_person_relationships
  ),
  documentFiles: serialized.documentFiles.map(
    deserializeUpdateApplication_updateApplication_MonitorApplication_person_documentFiles
  ),
  openApplications: serialized.openApplications.map(
    deserializeUpdateApplication_updateApplication_MonitorApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializeUpdateApplication_updateApplication_MonitorApplication_person_openHouseholdMemberApplications
  ),
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_person = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_person
): UpdateApplication_updateApplication_MonitorApplication_personOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeUpdateApplication_updateApplication_MonitorApplication_person_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeUpdateApplication_updateApplication_MonitorApplication_person_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeUpdateApplication_updateApplication_MonitorApplication_person_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeUpdateApplication_updateApplication_MonitorApplication_person_deductions
  ),
  relationships: deserialized.relationships.map(
    serializeUpdateApplication_updateApplication_MonitorApplication_person_relationships
  ),
  documentFiles: deserialized.documentFiles.map(
    serializeUpdateApplication_updateApplication_MonitorApplication_person_documentFiles
  ),
  openApplications: deserialized.openApplications.map(
    serializeUpdateApplication_updateApplication_MonitorApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializeUpdateApplication_updateApplication_MonitorApplication_person_openHouseholdMemberApplications
  ),
})
export interface UpdateApplication_updateApplication_MonitorApplication_assignedTo {
  __typename: 'User'
  id: string
  email: string
  name: string | null
  isCurrentUser: boolean
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_assignedTo = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_assignedToOrig
): UpdateApplication_updateApplication_MonitorApplication_assignedTo => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_assignedTo = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_assignedTo
): UpdateApplication_updateApplication_MonitorApplication_assignedToOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_phoneNumbers_esignSession_esignWizardsOrig
): UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards
): UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards[]
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_phoneNumbers_esignSession = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_phoneNumbers_esignSessionOrig
): UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_phoneNumbers_esignSession = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_phoneNumbers_esignSession
): UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards
  ),
})
export interface UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_phoneNumbers_esignSession | null
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_phoneNumbers = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_phoneNumbersOrig
): UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_phoneNumbers = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_phoneNumbers
): UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplicationOrig
): UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication
): UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplicationOrig
): UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication
): UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application_SlideApplication = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application_SlideApplicationOrig
): UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application_SlideApplication = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application_SlideApplication
): UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application =
  | UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication
  | UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication
  | UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application_SlideApplication
export const deserializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_applicationOrig
): UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application'
  )
}
export const serializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application
): UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application'
  )
}
export interface UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application | null
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomesOrig
): UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes
): UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_incomeSources_esignSession_esignWizards = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_incomeSources_esignSession_esignWizardsOrig
): UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_incomeSources_esignSession_esignWizards = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_incomeSources_esignSession_esignWizards
): UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_incomeSources_esignSession_esignWizards[]
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_incomeSources_esignSession = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_incomeSources_esignSessionOrig
): UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_incomeSources_esignSession_esignWizards
  ),
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_incomeSources_esignSession = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_incomeSources_esignSession
): UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_incomeSources_esignSession_esignWizards
  ),
})
export interface UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_incomeSources_esignSession | null
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_incomeSources = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_incomeSourcesOrig
): UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_incomeSources = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_incomeSources
): UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_deductions = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_deductionsOrig
): UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_deductions => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_deductions = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_deductions
): UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_deductionsOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_documentFiles {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_documentFiles = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_documentFilesOrig
): UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_documentFiles => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_documentFiles = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_documentFiles
): UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_documentFilesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface UpdateApplication_updateApplication_MonitorApplication_householdMembers_person {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes[]
  incomeSources: UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_incomeSources[]
  deductions: UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
  documentFiles: UpdateApplication_updateApplication_MonitorApplication_householdMembers_person_documentFiles[]
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_householdMembers_personOrig
): UpdateApplication_updateApplication_MonitorApplication_householdMembers_person => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_deductions
  ),
  documentFiles: serialized.documentFiles.map(
    deserializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_documentFiles
  ),
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_householdMembers_person
): UpdateApplication_updateApplication_MonitorApplication_householdMembers_personOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_deductions
  ),
  documentFiles: deserialized.documentFiles.map(
    serializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person_documentFiles
  ),
})
export interface UpdateApplication_updateApplication_MonitorApplication_householdMembers {
  __typename: 'ApplicationHouseholdMember'
  id: string
  wantsCoverage: boolean | null
  person: UpdateApplication_updateApplication_MonitorApplication_householdMembers_person
  createdAt: Date
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_householdMembers = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_householdMembersOrig
): UpdateApplication_updateApplication_MonitorApplication_householdMembers => ({
  ...serialized,
  person: deserializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person(
    serialized.person
  ),
  createdAt: parseDate(serialized.createdAt),
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_householdMembers = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_householdMembers
): UpdateApplication_updateApplication_MonitorApplication_householdMembersOrig => ({
  ...deserialized,
  person: serializeUpdateApplication_updateApplication_MonitorApplication_householdMembers_person(
    deserialized.person
  ),
  createdAt: formatISO(deserialized.createdAt),
})
export interface UpdateApplication_updateApplication_MonitorApplication_documents_files {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_documents_files = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_documents_filesOrig
): UpdateApplication_updateApplication_MonitorApplication_documents_files => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_documents_files = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_documents_files
): UpdateApplication_updateApplication_MonitorApplication_documents_filesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface UpdateApplication_updateApplication_MonitorApplication_documents_person {
  __typename: 'Person'
  id: string
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_documents_person = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_documents_personOrig
): UpdateApplication_updateApplication_MonitorApplication_documents_person => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_documents_person = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_documents_person
): UpdateApplication_updateApplication_MonitorApplication_documents_personOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_MonitorApplication_documents_application {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_documents_application = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_documents_applicationOrig
): UpdateApplication_updateApplication_MonitorApplication_documents_application => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_documents_application = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_documents_application
): UpdateApplication_updateApplication_MonitorApplication_documents_applicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_MonitorApplication_documents {
  __typename: 'Document'
  id: string
  documentType: string
  complete: boolean | null
  files: UpdateApplication_updateApplication_MonitorApplication_documents_files[]
  updatedAt: Date
  notes: string | null
  person: UpdateApplication_updateApplication_MonitorApplication_documents_person | null
  application: UpdateApplication_updateApplication_MonitorApplication_documents_application
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_documents = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_documentsOrig
): UpdateApplication_updateApplication_MonitorApplication_documents => ({
  ...serialized,
  files: serialized.files.map(
    deserializeUpdateApplication_updateApplication_MonitorApplication_documents_files
  ),
  updatedAt: parseDate(serialized.updatedAt),
  person:
    serialized.person != null
      ? deserializeUpdateApplication_updateApplication_MonitorApplication_documents_person(
          serialized.person
        )
      : serialized.person,
  application: deserializeUpdateApplication_updateApplication_MonitorApplication_documents_application(
    serialized.application
  ),
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_documents = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_documents
): UpdateApplication_updateApplication_MonitorApplication_documentsOrig => ({
  ...deserialized,
  files: deserialized.files.map(
    serializeUpdateApplication_updateApplication_MonitorApplication_documents_files
  ),
  updatedAt: formatISO(deserialized.updatedAt),
  person:
    deserialized.person != null
      ? serializeUpdateApplication_updateApplication_MonitorApplication_documents_person(
          deserialized.person
        )
      : deserialized.person,
  application: serializeUpdateApplication_updateApplication_MonitorApplication_documents_application(
    deserialized.application
  ),
})
export interface UpdateApplication_updateApplication_MonitorApplication_documentFiles_documents {
  __typename: 'Document'
  id: string
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_documentFiles_documents = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_documentFiles_documentsOrig
): UpdateApplication_updateApplication_MonitorApplication_documentFiles_documents => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_documentFiles_documents = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_documentFiles_documents
): UpdateApplication_updateApplication_MonitorApplication_documentFiles_documentsOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_MonitorApplication_documentFiles {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
  documents: UpdateApplication_updateApplication_MonitorApplication_documentFiles_documents[]
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_documentFiles = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_documentFilesOrig
): UpdateApplication_updateApplication_MonitorApplication_documentFiles => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
  documents: serialized.documents.map(
    deserializeUpdateApplication_updateApplication_MonitorApplication_documentFiles_documents
  ),
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_documentFiles = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_documentFiles
): UpdateApplication_updateApplication_MonitorApplication_documentFilesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
  documents: deserialized.documents.map(
    serializeUpdateApplication_updateApplication_MonitorApplication_documentFiles_documents
  ),
})
export interface UpdateApplication_updateApplication_MonitorApplication_benefitOutcomes_person {
  __typename: 'Person'
  id: string
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_benefitOutcomes_person = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_benefitOutcomes_personOrig
): UpdateApplication_updateApplication_MonitorApplication_benefitOutcomes_person => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_benefitOutcomes_person = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_benefitOutcomes_person
): UpdateApplication_updateApplication_MonitorApplication_benefitOutcomes_personOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_MonitorApplication_benefitOutcomes_application {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_benefitOutcomes_application = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_benefitOutcomes_applicationOrig
): UpdateApplication_updateApplication_MonitorApplication_benefitOutcomes_application => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_benefitOutcomes_application = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_benefitOutcomes_application
): UpdateApplication_updateApplication_MonitorApplication_benefitOutcomes_applicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_MonitorApplication_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  person: UpdateApplication_updateApplication_MonitorApplication_benefitOutcomes_person
  application: UpdateApplication_updateApplication_MonitorApplication_benefitOutcomes_application | null
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_benefitOutcomes = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_benefitOutcomesOrig
): UpdateApplication_updateApplication_MonitorApplication_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  person: deserializeUpdateApplication_updateApplication_MonitorApplication_benefitOutcomes_person(
    serialized.person
  ),
  application:
    serialized.application != null
      ? deserializeUpdateApplication_updateApplication_MonitorApplication_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_benefitOutcomes = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_benefitOutcomes
): UpdateApplication_updateApplication_MonitorApplication_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  person: serializeUpdateApplication_updateApplication_MonitorApplication_benefitOutcomes_person(
    deserialized.person
  ),
  application:
    deserialized.application != null
      ? serializeUpdateApplication_updateApplication_MonitorApplication_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface UpdateApplication_updateApplication_MonitorApplication_accountOnDateOfService {
  __typename: 'Account'
  id: string
  hospitalAccountId: string | null
  dateOfService: Date
  timeOfService: string | null
  serviceTimeZone: string
  facility: string
  department: string
  location: string | null
  insuranceType: string
  status: string
  createdAt: Date
  updatedAt: Date
  notes: string | null
  accountAmount: number | null
  njmmisCheck: string | null
  previousInsurance: string | null
  invoiceMonth: string | null
  invoiceYear: string | null
  dischargeDate: Date | null
  isScheduled: boolean
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_accountOnDateOfService = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_accountOnDateOfServiceOrig
): UpdateApplication_updateApplication_MonitorApplication_accountOnDateOfService => ({
  ...serialized,
  dateOfService: parseDate(serialized.dateOfService),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  njmmisCheck:
    serialized.njmmisCheck != null
      ? deserializeNjmmisCheckResult(serialized.njmmisCheck)
      : serialized.njmmisCheck,
  dischargeDate:
    serialized.dischargeDate != null
      ? parseDate(serialized.dischargeDate)
      : serialized.dischargeDate,
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_accountOnDateOfService = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_accountOnDateOfService
): UpdateApplication_updateApplication_MonitorApplication_accountOnDateOfServiceOrig => ({
  ...deserialized,
  dateOfService: formatISODate(deserialized.dateOfService),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  njmmisCheck:
    deserialized.njmmisCheck != null
      ? serializeNjmmisCheckResult(deserialized.njmmisCheck)
      : deserialized.njmmisCheck,
  dischargeDate:
    deserialized.dischargeDate != null
      ? formatISODate(deserialized.dischargeDate)
      : deserialized.dischargeDate,
})
export interface UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizards = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizardsOrig
): UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizards = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizards
): UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizards[]
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSession = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSessionOrig
): UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSession = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSession
): UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizards
  ),
})
export interface UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSession | null
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_phoneNumbers = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_phoneNumbersOrig
): UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_phoneNumbers = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_phoneNumbers
): UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplication = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplicationOrig
): UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplication = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplication
): UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplication = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplicationOrig
): UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplication = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplication
): UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplication = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplicationOrig
): UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplication = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplication
): UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application =
  | UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplication
  | UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplication
  | UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplication
export const deserializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_applicationOrig
): UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application'
  )
}
export const serializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application
): UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application'
  )
}
export interface UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application | null
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomesOrig
): UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes
): UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_incomeSources_esignSession_esignWizards = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_incomeSources_esignSession_esignWizardsOrig
): UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_incomeSources_esignSession_esignWizards = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_incomeSources_esignSession_esignWizards
): UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_incomeSources_esignSession_esignWizards[]
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_incomeSources_esignSession = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_incomeSources_esignSessionOrig
): UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_incomeSources_esignSession_esignWizards
  ),
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_incomeSources_esignSession = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_incomeSources_esignSession
): UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_incomeSources_esignSession_esignWizards
  ),
})
export interface UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_incomeSources_esignSession | null
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_incomeSources = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_incomeSourcesOrig
): UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_incomeSources = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_incomeSources
): UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_deductions = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_deductionsOrig
): UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_deductions => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_deductions = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_deductions
): UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_deductionsOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes[]
  incomeSources: UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_incomeSources[]
  deductions: UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact = (
  serialized: UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContactOrig
): UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_deductions
  ),
})
export const serializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact
): UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContactOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact_deductions
  ),
})
export interface UpdateApplication_updateApplication_MonitorApplication {
  __typename: 'MonitorApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  person: UpdateApplication_updateApplication_MonitorApplication_person
  assignedTo: UpdateApplication_updateApplication_MonitorApplication_assignedTo | null
  householdMembers: UpdateApplication_updateApplication_MonitorApplication_householdMembers[]
  documents: UpdateApplication_updateApplication_MonitorApplication_documents[]
  documentFiles: UpdateApplication_updateApplication_MonitorApplication_documentFiles[]
  benefitOutcomes: UpdateApplication_updateApplication_MonitorApplication_benefitOutcomes[]
  accountOnDateOfService: UpdateApplication_updateApplication_MonitorApplication_accountOnDateOfService | null
  submitDate: Date | null
  applicationType: string | null
  submitMethod: string | null
  location: string | null
  countyName: string | null
  darSubmitDate: Date | null
  confirmationNumber: string | null
  policyId: string | null
  notes: string | null
  primaryPointOfContact: UpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact | null
  initialDateOfService: Date | null
}
export const deserializeUpdateApplication_updateApplication_MonitorApplication = (
  serialized: UpdateApplication_updateApplication_MonitorApplicationOrig
): UpdateApplication_updateApplication_MonitorApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  person: deserializeUpdateApplication_updateApplication_MonitorApplication_person(
    serialized.person
  ),
  assignedTo:
    serialized.assignedTo != null
      ? deserializeUpdateApplication_updateApplication_MonitorApplication_assignedTo(
          serialized.assignedTo
        )
      : serialized.assignedTo,
  householdMembers: serialized.householdMembers.map(
    deserializeUpdateApplication_updateApplication_MonitorApplication_householdMembers
  ),
  documents: serialized.documents.map(
    deserializeUpdateApplication_updateApplication_MonitorApplication_documents
  ),
  documentFiles: serialized.documentFiles.map(
    deserializeUpdateApplication_updateApplication_MonitorApplication_documentFiles
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeUpdateApplication_updateApplication_MonitorApplication_benefitOutcomes
  ),
  accountOnDateOfService:
    serialized.accountOnDateOfService != null
      ? deserializeUpdateApplication_updateApplication_MonitorApplication_accountOnDateOfService(
          serialized.accountOnDateOfService
        )
      : serialized.accountOnDateOfService,
  submitDate:
    serialized.submitDate != null
      ? parseDate(serialized.submitDate)
      : serialized.submitDate,
  darSubmitDate:
    serialized.darSubmitDate != null
      ? parseDate(serialized.darSubmitDate)
      : serialized.darSubmitDate,
  primaryPointOfContact:
    serialized.primaryPointOfContact != null
      ? deserializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact(
          serialized.primaryPointOfContact
        )
      : serialized.primaryPointOfContact,
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
})
export const serializeUpdateApplication_updateApplication_MonitorApplication = (
  deserialized: UpdateApplication_updateApplication_MonitorApplication
): UpdateApplication_updateApplication_MonitorApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  person: serializeUpdateApplication_updateApplication_MonitorApplication_person(
    deserialized.person
  ),
  assignedTo:
    deserialized.assignedTo != null
      ? serializeUpdateApplication_updateApplication_MonitorApplication_assignedTo(
          deserialized.assignedTo
        )
      : deserialized.assignedTo,
  householdMembers: deserialized.householdMembers.map(
    serializeUpdateApplication_updateApplication_MonitorApplication_householdMembers
  ),
  documents: deserialized.documents.map(
    serializeUpdateApplication_updateApplication_MonitorApplication_documents
  ),
  documentFiles: deserialized.documentFiles.map(
    serializeUpdateApplication_updateApplication_MonitorApplication_documentFiles
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeUpdateApplication_updateApplication_MonitorApplication_benefitOutcomes
  ),
  accountOnDateOfService:
    deserialized.accountOnDateOfService != null
      ? serializeUpdateApplication_updateApplication_MonitorApplication_accountOnDateOfService(
          deserialized.accountOnDateOfService
        )
      : deserialized.accountOnDateOfService,
  submitDate:
    deserialized.submitDate != null
      ? formatISODate(deserialized.submitDate)
      : deserialized.submitDate,
  darSubmitDate:
    deserialized.darSubmitDate != null
      ? formatISODate(deserialized.darSubmitDate)
      : deserialized.darSubmitDate,
  primaryPointOfContact:
    deserialized.primaryPointOfContact != null
      ? serializeUpdateApplication_updateApplication_MonitorApplication_primaryPointOfContact(
          deserialized.primaryPointOfContact
        )
      : deserialized.primaryPointOfContact,
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
})
export interface UpdateApplication_updateApplication_CharityCareApplication_person_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_person_phoneNumbers_esignSession_esignWizards = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_person_phoneNumbers_esignSession_esignWizardsOrig
): UpdateApplication_updateApplication_CharityCareApplication_person_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_person_phoneNumbers_esignSession_esignWizards = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_person_phoneNumbers_esignSession_esignWizards
): UpdateApplication_updateApplication_CharityCareApplication_person_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface UpdateApplication_updateApplication_CharityCareApplication_person_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: UpdateApplication_updateApplication_CharityCareApplication_person_phoneNumbers_esignSession_esignWizards[]
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_person_phoneNumbers_esignSession = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_person_phoneNumbers_esignSessionOrig
): UpdateApplication_updateApplication_CharityCareApplication_person_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeUpdateApplication_updateApplication_CharityCareApplication_person_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_person_phoneNumbers_esignSession = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_person_phoneNumbers_esignSession
): UpdateApplication_updateApplication_CharityCareApplication_person_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeUpdateApplication_updateApplication_CharityCareApplication_person_phoneNumbers_esignSession_esignWizards
  ),
})
export interface UpdateApplication_updateApplication_CharityCareApplication_person_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: UpdateApplication_updateApplication_CharityCareApplication_person_phoneNumbers_esignSession | null
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_person_phoneNumbers = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_person_phoneNumbersOrig
): UpdateApplication_updateApplication_CharityCareApplication_person_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeUpdateApplication_updateApplication_CharityCareApplication_person_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_person_phoneNumbers = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_person_phoneNumbers
): UpdateApplication_updateApplication_CharityCareApplication_person_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeUpdateApplication_updateApplication_CharityCareApplication_person_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface UpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplication = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplicationOrig
): UpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplication = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplication
): UpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplication = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplicationOrig
): UpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplication = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplication
): UpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application_SlideApplication = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application_SlideApplicationOrig
): UpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application_SlideApplication = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application_SlideApplication
): UpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type UpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application =
  | UpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplication
  | UpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplication
  | UpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application_SlideApplication
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_applicationOrig
): UpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializeUpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeUpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeUpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application'
  )
}
export const serializeUpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application
): UpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializeUpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeUpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeUpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application'
  )
}
export interface UpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: UpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application | null
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomesOrig
): UpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializeUpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes
): UpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializeUpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface UpdateApplication_updateApplication_CharityCareApplication_person_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_person_incomeSources_esignSession_esignWizards = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_person_incomeSources_esignSession_esignWizardsOrig
): UpdateApplication_updateApplication_CharityCareApplication_person_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_person_incomeSources_esignSession_esignWizards = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_person_incomeSources_esignSession_esignWizards
): UpdateApplication_updateApplication_CharityCareApplication_person_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface UpdateApplication_updateApplication_CharityCareApplication_person_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: UpdateApplication_updateApplication_CharityCareApplication_person_incomeSources_esignSession_esignWizards[]
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_person_incomeSources_esignSession = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_person_incomeSources_esignSessionOrig
): UpdateApplication_updateApplication_CharityCareApplication_person_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeUpdateApplication_updateApplication_CharityCareApplication_person_incomeSources_esignSession_esignWizards
  ),
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_person_incomeSources_esignSession = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_person_incomeSources_esignSession
): UpdateApplication_updateApplication_CharityCareApplication_person_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeUpdateApplication_updateApplication_CharityCareApplication_person_incomeSources_esignSession_esignWizards
  ),
})
export interface UpdateApplication_updateApplication_CharityCareApplication_person_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: UpdateApplication_updateApplication_CharityCareApplication_person_incomeSources_esignSession | null
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_person_incomeSources = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_person_incomeSourcesOrig
): UpdateApplication_updateApplication_CharityCareApplication_person_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeUpdateApplication_updateApplication_CharityCareApplication_person_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_person_incomeSources = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_person_incomeSources
): UpdateApplication_updateApplication_CharityCareApplication_person_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeUpdateApplication_updateApplication_CharityCareApplication_person_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface UpdateApplication_updateApplication_CharityCareApplication_person_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_person_deductions = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_person_deductionsOrig
): UpdateApplication_updateApplication_CharityCareApplication_person_deductions => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_person_deductions = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_person_deductions
): UpdateApplication_updateApplication_CharityCareApplication_person_deductionsOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizardsOrig
): UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards
): UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards[]
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSession = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSessionOrig
): UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSession = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSession
): UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards
  ),
})
export interface UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSession | null
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_phoneNumbers = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_phoneNumbersOrig
): UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_phoneNumbers = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_phoneNumbers
): UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplicationOrig
): UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication
): UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplicationOrig
): UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication
): UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplicationOrig
): UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication
): UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application =
  | UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication
  | UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication
  | UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_applicationOrig
): UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application'
  )
}
export const serializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application
): UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application'
  )
}
export interface UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application | null
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomesOrig
): UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes
): UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizardsOrig
): UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards
): UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards[]
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSession = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSessionOrig
): UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards
  ),
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSession = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSession
): UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards
  ),
})
export interface UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSession | null
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_incomeSources = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_incomeSourcesOrig
): UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_incomeSources = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_incomeSources
): UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_deductions = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_deductionsOrig
): UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_deductions => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_deductions = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_deductions
): UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_deductionsOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes[]
  incomeSources: UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_incomeSources[]
  deductions: UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPersonOrig
): UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_deductions
  ),
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson
): UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPersonOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson_deductions
  ),
})
export interface UpdateApplication_updateApplication_CharityCareApplication_person_relationships {
  __typename: 'Relationship'
  id: string
  relationshipType: string | null
  reverseRelationshipType: string | null
  liveTogether: boolean | null
  otherPerson: UpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_person_relationshipsOrig
): UpdateApplication_updateApplication_CharityCareApplication_person_relationships => ({
  ...serialized,
  otherPerson: deserializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson(
    serialized.otherPerson
  ),
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_person_relationships
): UpdateApplication_updateApplication_CharityCareApplication_person_relationshipsOrig => ({
  ...deserialized,
  otherPerson: serializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships_otherPerson(
    deserialized.otherPerson
  ),
})
export interface UpdateApplication_updateApplication_CharityCareApplication_person_documentFiles {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_person_documentFiles = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_person_documentFilesOrig
): UpdateApplication_updateApplication_CharityCareApplication_person_documentFiles => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_person_documentFiles = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_person_documentFiles
): UpdateApplication_updateApplication_CharityCareApplication_person_documentFilesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface UpdateApplication_updateApplication_CharityCareApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_person_openApplications_MedicaidApplication = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_person_openApplications_MedicaidApplicationOrig
): UpdateApplication_updateApplication_CharityCareApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_person_openApplications_MedicaidApplication = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_person_openApplications_MedicaidApplication
): UpdateApplication_updateApplication_CharityCareApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface UpdateApplication_updateApplication_CharityCareApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_person_openApplications_CharityCareApplication = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_person_openApplications_CharityCareApplicationOrig
): UpdateApplication_updateApplication_CharityCareApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_person_openApplications_CharityCareApplication = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_person_openApplications_CharityCareApplication
): UpdateApplication_updateApplication_CharityCareApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface UpdateApplication_updateApplication_CharityCareApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_person_openApplications_SlideApplication = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_person_openApplications_SlideApplicationOrig
): UpdateApplication_updateApplication_CharityCareApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_person_openApplications_SlideApplication = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_person_openApplications_SlideApplication
): UpdateApplication_updateApplication_CharityCareApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface UpdateApplication_updateApplication_CharityCareApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_person_openApplications_RyanWhiteApplication = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_person_openApplications_RyanWhiteApplicationOrig
): UpdateApplication_updateApplication_CharityCareApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_person_openApplications_RyanWhiteApplication
): UpdateApplication_updateApplication_CharityCareApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type UpdateApplication_updateApplication_CharityCareApplication_person_openApplications =
  | UpdateApplication_updateApplication_CharityCareApplication_person_openApplications_MedicaidApplication
  | UpdateApplication_updateApplication_CharityCareApplication_person_openApplications_CharityCareApplication
  | UpdateApplication_updateApplication_CharityCareApplication_person_openApplications_SlideApplication
  | UpdateApplication_updateApplication_CharityCareApplication_person_openApplications_RyanWhiteApplication
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_person_openApplications = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_person_openApplicationsOrig
): UpdateApplication_updateApplication_CharityCareApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializeUpdateApplication_updateApplication_CharityCareApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeUpdateApplication_updateApplication_CharityCareApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeUpdateApplication_updateApplication_CharityCareApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeUpdateApplication_updateApplication_CharityCareApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_CharityCareApplication_person_openApplications'
  )
}
export const serializeUpdateApplication_updateApplication_CharityCareApplication_person_openApplications = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_person_openApplications
): UpdateApplication_updateApplication_CharityCareApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializeUpdateApplication_updateApplication_CharityCareApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeUpdateApplication_updateApplication_CharityCareApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeUpdateApplication_updateApplication_CharityCareApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeUpdateApplication_updateApplication_CharityCareApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_CharityCareApplication_person_openApplications'
  )
}
export interface UpdateApplication_updateApplication_CharityCareApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_person_openHouseholdMemberApplications = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_person_openHouseholdMemberApplicationsOrig
): UpdateApplication_updateApplication_CharityCareApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_person_openHouseholdMemberApplications = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_person_openHouseholdMemberApplications
): UpdateApplication_updateApplication_CharityCareApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface UpdateApplication_updateApplication_CharityCareApplication_person {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: UpdateApplication_updateApplication_CharityCareApplication_person_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: UpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes[]
  incomeSources: UpdateApplication_updateApplication_CharityCareApplication_person_incomeSources[]
  deductions: UpdateApplication_updateApplication_CharityCareApplication_person_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
  relationships: UpdateApplication_updateApplication_CharityCareApplication_person_relationships[]
  documentFiles: UpdateApplication_updateApplication_CharityCareApplication_person_documentFiles[]
  openApplications: UpdateApplication_updateApplication_CharityCareApplication_person_openApplications[]
  openHouseholdMemberApplications: UpdateApplication_updateApplication_CharityCareApplication_person_openHouseholdMemberApplications[]
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_person = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_personOrig
): UpdateApplication_updateApplication_CharityCareApplication_person => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeUpdateApplication_updateApplication_CharityCareApplication_person_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeUpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeUpdateApplication_updateApplication_CharityCareApplication_person_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeUpdateApplication_updateApplication_CharityCareApplication_person_deductions
  ),
  relationships: serialized.relationships.map(
    deserializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships
  ),
  documentFiles: serialized.documentFiles.map(
    deserializeUpdateApplication_updateApplication_CharityCareApplication_person_documentFiles
  ),
  openApplications: serialized.openApplications.map(
    deserializeUpdateApplication_updateApplication_CharityCareApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializeUpdateApplication_updateApplication_CharityCareApplication_person_openHouseholdMemberApplications
  ),
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_person = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_person
): UpdateApplication_updateApplication_CharityCareApplication_personOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeUpdateApplication_updateApplication_CharityCareApplication_person_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeUpdateApplication_updateApplication_CharityCareApplication_person_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeUpdateApplication_updateApplication_CharityCareApplication_person_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeUpdateApplication_updateApplication_CharityCareApplication_person_deductions
  ),
  relationships: deserialized.relationships.map(
    serializeUpdateApplication_updateApplication_CharityCareApplication_person_relationships
  ),
  documentFiles: deserialized.documentFiles.map(
    serializeUpdateApplication_updateApplication_CharityCareApplication_person_documentFiles
  ),
  openApplications: deserialized.openApplications.map(
    serializeUpdateApplication_updateApplication_CharityCareApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializeUpdateApplication_updateApplication_CharityCareApplication_person_openHouseholdMemberApplications
  ),
})
export interface UpdateApplication_updateApplication_CharityCareApplication_assignedTo {
  __typename: 'User'
  id: string
  email: string
  name: string | null
  isCurrentUser: boolean
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_assignedTo = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_assignedToOrig
): UpdateApplication_updateApplication_CharityCareApplication_assignedTo => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_assignedTo = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_assignedTo
): UpdateApplication_updateApplication_CharityCareApplication_assignedToOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_phoneNumbers_esignSession_esignWizardsOrig
): UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards
): UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards[]
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_phoneNumbers_esignSession = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_phoneNumbers_esignSessionOrig
): UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_phoneNumbers_esignSession = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_phoneNumbers_esignSession
): UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards
  ),
})
export interface UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_phoneNumbers_esignSession | null
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_phoneNumbers = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_phoneNumbersOrig
): UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_phoneNumbers = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_phoneNumbers
): UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplicationOrig
): UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication
): UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplicationOrig
): UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication
): UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application_SlideApplication = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application_SlideApplicationOrig
): UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application_SlideApplication = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application_SlideApplication
): UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application =
  | UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication
  | UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication
  | UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application_SlideApplication
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_applicationOrig
): UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application'
  )
}
export const serializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application
): UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application'
  )
}
export interface UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application | null
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomesOrig
): UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes
): UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_incomeSources_esignSession_esignWizards = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_incomeSources_esignSession_esignWizardsOrig
): UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_incomeSources_esignSession_esignWizards = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_incomeSources_esignSession_esignWizards
): UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_incomeSources_esignSession_esignWizards[]
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_incomeSources_esignSession = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_incomeSources_esignSessionOrig
): UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_incomeSources_esignSession_esignWizards
  ),
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_incomeSources_esignSession = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_incomeSources_esignSession
): UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_incomeSources_esignSession_esignWizards
  ),
})
export interface UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_incomeSources_esignSession | null
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_incomeSources = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_incomeSourcesOrig
): UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_incomeSources = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_incomeSources
): UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_deductions = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_deductionsOrig
): UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_deductions => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_deductions = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_deductions
): UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_deductionsOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_documentFiles {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_documentFiles = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_documentFilesOrig
): UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_documentFiles => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_documentFiles = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_documentFiles
): UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_documentFilesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes[]
  incomeSources: UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_incomeSources[]
  deductions: UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
  documentFiles: UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_documentFiles[]
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_householdMembers_personOrig
): UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_deductions
  ),
  documentFiles: serialized.documentFiles.map(
    deserializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_documentFiles
  ),
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person
): UpdateApplication_updateApplication_CharityCareApplication_householdMembers_personOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_deductions
  ),
  documentFiles: deserialized.documentFiles.map(
    serializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person_documentFiles
  ),
})
export interface UpdateApplication_updateApplication_CharityCareApplication_householdMembers {
  __typename: 'ApplicationHouseholdMember'
  id: string
  wantsCoverage: boolean | null
  person: UpdateApplication_updateApplication_CharityCareApplication_householdMembers_person
  createdAt: Date
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_householdMembersOrig
): UpdateApplication_updateApplication_CharityCareApplication_householdMembers => ({
  ...serialized,
  person: deserializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person(
    serialized.person
  ),
  createdAt: parseDate(serialized.createdAt),
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_householdMembers
): UpdateApplication_updateApplication_CharityCareApplication_householdMembersOrig => ({
  ...deserialized,
  person: serializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers_person(
    deserialized.person
  ),
  createdAt: formatISO(deserialized.createdAt),
})
export interface UpdateApplication_updateApplication_CharityCareApplication_documents_files {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_documents_files = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_documents_filesOrig
): UpdateApplication_updateApplication_CharityCareApplication_documents_files => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_documents_files = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_documents_files
): UpdateApplication_updateApplication_CharityCareApplication_documents_filesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface UpdateApplication_updateApplication_CharityCareApplication_documents_person {
  __typename: 'Person'
  id: string
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_documents_person = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_documents_personOrig
): UpdateApplication_updateApplication_CharityCareApplication_documents_person => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_documents_person = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_documents_person
): UpdateApplication_updateApplication_CharityCareApplication_documents_personOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_CharityCareApplication_documents_application {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_documents_application = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_documents_applicationOrig
): UpdateApplication_updateApplication_CharityCareApplication_documents_application => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_documents_application = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_documents_application
): UpdateApplication_updateApplication_CharityCareApplication_documents_applicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_CharityCareApplication_documents {
  __typename: 'Document'
  id: string
  documentType: string
  complete: boolean | null
  files: UpdateApplication_updateApplication_CharityCareApplication_documents_files[]
  updatedAt: Date
  notes: string | null
  person: UpdateApplication_updateApplication_CharityCareApplication_documents_person | null
  application: UpdateApplication_updateApplication_CharityCareApplication_documents_application
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_documents = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_documentsOrig
): UpdateApplication_updateApplication_CharityCareApplication_documents => ({
  ...serialized,
  files: serialized.files.map(
    deserializeUpdateApplication_updateApplication_CharityCareApplication_documents_files
  ),
  updatedAt: parseDate(serialized.updatedAt),
  person:
    serialized.person != null
      ? deserializeUpdateApplication_updateApplication_CharityCareApplication_documents_person(
          serialized.person
        )
      : serialized.person,
  application: deserializeUpdateApplication_updateApplication_CharityCareApplication_documents_application(
    serialized.application
  ),
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_documents = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_documents
): UpdateApplication_updateApplication_CharityCareApplication_documentsOrig => ({
  ...deserialized,
  files: deserialized.files.map(
    serializeUpdateApplication_updateApplication_CharityCareApplication_documents_files
  ),
  updatedAt: formatISO(deserialized.updatedAt),
  person:
    deserialized.person != null
      ? serializeUpdateApplication_updateApplication_CharityCareApplication_documents_person(
          deserialized.person
        )
      : deserialized.person,
  application: serializeUpdateApplication_updateApplication_CharityCareApplication_documents_application(
    deserialized.application
  ),
})
export interface UpdateApplication_updateApplication_CharityCareApplication_documentFiles_documents {
  __typename: 'Document'
  id: string
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_documentFiles_documents = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_documentFiles_documentsOrig
): UpdateApplication_updateApplication_CharityCareApplication_documentFiles_documents => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_documentFiles_documents = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_documentFiles_documents
): UpdateApplication_updateApplication_CharityCareApplication_documentFiles_documentsOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_CharityCareApplication_documentFiles {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
  documents: UpdateApplication_updateApplication_CharityCareApplication_documentFiles_documents[]
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_documentFiles = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_documentFilesOrig
): UpdateApplication_updateApplication_CharityCareApplication_documentFiles => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
  documents: serialized.documents.map(
    deserializeUpdateApplication_updateApplication_CharityCareApplication_documentFiles_documents
  ),
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_documentFiles = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_documentFiles
): UpdateApplication_updateApplication_CharityCareApplication_documentFilesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
  documents: deserialized.documents.map(
    serializeUpdateApplication_updateApplication_CharityCareApplication_documentFiles_documents
  ),
})
export interface UpdateApplication_updateApplication_CharityCareApplication_benefitOutcomes_person {
  __typename: 'Person'
  id: string
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_benefitOutcomes_person = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_benefitOutcomes_personOrig
): UpdateApplication_updateApplication_CharityCareApplication_benefitOutcomes_person => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_benefitOutcomes_person = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_benefitOutcomes_person
): UpdateApplication_updateApplication_CharityCareApplication_benefitOutcomes_personOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_CharityCareApplication_benefitOutcomes_application {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_benefitOutcomes_application = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_benefitOutcomes_applicationOrig
): UpdateApplication_updateApplication_CharityCareApplication_benefitOutcomes_application => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_benefitOutcomes_application = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_benefitOutcomes_application
): UpdateApplication_updateApplication_CharityCareApplication_benefitOutcomes_applicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_CharityCareApplication_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  person: UpdateApplication_updateApplication_CharityCareApplication_benefitOutcomes_person
  application: UpdateApplication_updateApplication_CharityCareApplication_benefitOutcomes_application | null
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_benefitOutcomes = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_benefitOutcomesOrig
): UpdateApplication_updateApplication_CharityCareApplication_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  person: deserializeUpdateApplication_updateApplication_CharityCareApplication_benefitOutcomes_person(
    serialized.person
  ),
  application:
    serialized.application != null
      ? deserializeUpdateApplication_updateApplication_CharityCareApplication_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_benefitOutcomes = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_benefitOutcomes
): UpdateApplication_updateApplication_CharityCareApplication_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  person: serializeUpdateApplication_updateApplication_CharityCareApplication_benefitOutcomes_person(
    deserialized.person
  ),
  application:
    deserialized.application != null
      ? serializeUpdateApplication_updateApplication_CharityCareApplication_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface UpdateApplication_updateApplication_CharityCareApplication_accountOnDateOfService {
  __typename: 'Account'
  id: string
  hospitalAccountId: string | null
  dateOfService: Date
  timeOfService: string | null
  serviceTimeZone: string
  facility: string
  department: string
  location: string | null
  insuranceType: string
  status: string
  createdAt: Date
  updatedAt: Date
  notes: string | null
  accountAmount: number | null
  njmmisCheck: string | null
  previousInsurance: string | null
  invoiceMonth: string | null
  invoiceYear: string | null
  dischargeDate: Date | null
  isScheduled: boolean
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication_accountOnDateOfService = (
  serialized: UpdateApplication_updateApplication_CharityCareApplication_accountOnDateOfServiceOrig
): UpdateApplication_updateApplication_CharityCareApplication_accountOnDateOfService => ({
  ...serialized,
  dateOfService: parseDate(serialized.dateOfService),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  njmmisCheck:
    serialized.njmmisCheck != null
      ? deserializeNjmmisCheckResult(serialized.njmmisCheck)
      : serialized.njmmisCheck,
  dischargeDate:
    serialized.dischargeDate != null
      ? parseDate(serialized.dischargeDate)
      : serialized.dischargeDate,
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication_accountOnDateOfService = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication_accountOnDateOfService
): UpdateApplication_updateApplication_CharityCareApplication_accountOnDateOfServiceOrig => ({
  ...deserialized,
  dateOfService: formatISODate(deserialized.dateOfService),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  njmmisCheck:
    deserialized.njmmisCheck != null
      ? serializeNjmmisCheckResult(deserialized.njmmisCheck)
      : deserialized.njmmisCheck,
  dischargeDate:
    deserialized.dischargeDate != null
      ? formatISODate(deserialized.dischargeDate)
      : deserialized.dischargeDate,
})
export interface UpdateApplication_updateApplication_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  person: UpdateApplication_updateApplication_CharityCareApplication_person
  assignedTo: UpdateApplication_updateApplication_CharityCareApplication_assignedTo | null
  householdMembers: UpdateApplication_updateApplication_CharityCareApplication_householdMembers[]
  documents: UpdateApplication_updateApplication_CharityCareApplication_documents[]
  documentFiles: UpdateApplication_updateApplication_CharityCareApplication_documentFiles[]
  benefitOutcomes: UpdateApplication_updateApplication_CharityCareApplication_benefitOutcomes[]
  accountOnDateOfService: UpdateApplication_updateApplication_CharityCareApplication_accountOnDateOfService | null
  initialDateOfService: Date | null
  dateOfApplication: Date | null
  requestedDateOfApplication: Date | null
  notes: string | null
  facility: string
  coveragePeriod: number | null
  charityCareType: string
}
export const deserializeUpdateApplication_updateApplication_CharityCareApplication = (
  serialized: UpdateApplication_updateApplication_CharityCareApplicationOrig
): UpdateApplication_updateApplication_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  person: deserializeUpdateApplication_updateApplication_CharityCareApplication_person(
    serialized.person
  ),
  assignedTo:
    serialized.assignedTo != null
      ? deserializeUpdateApplication_updateApplication_CharityCareApplication_assignedTo(
          serialized.assignedTo
        )
      : serialized.assignedTo,
  householdMembers: serialized.householdMembers.map(
    deserializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers
  ),
  documents: serialized.documents.map(
    deserializeUpdateApplication_updateApplication_CharityCareApplication_documents
  ),
  documentFiles: serialized.documentFiles.map(
    deserializeUpdateApplication_updateApplication_CharityCareApplication_documentFiles
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeUpdateApplication_updateApplication_CharityCareApplication_benefitOutcomes
  ),
  accountOnDateOfService:
    serialized.accountOnDateOfService != null
      ? deserializeUpdateApplication_updateApplication_CharityCareApplication_accountOnDateOfService(
          serialized.accountOnDateOfService
        )
      : serialized.accountOnDateOfService,
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  dateOfApplication:
    serialized.dateOfApplication != null
      ? parseDate(serialized.dateOfApplication)
      : serialized.dateOfApplication,
  requestedDateOfApplication:
    serialized.requestedDateOfApplication != null
      ? parseDate(serialized.requestedDateOfApplication)
      : serialized.requestedDateOfApplication,
})
export const serializeUpdateApplication_updateApplication_CharityCareApplication = (
  deserialized: UpdateApplication_updateApplication_CharityCareApplication
): UpdateApplication_updateApplication_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  person: serializeUpdateApplication_updateApplication_CharityCareApplication_person(
    deserialized.person
  ),
  assignedTo:
    deserialized.assignedTo != null
      ? serializeUpdateApplication_updateApplication_CharityCareApplication_assignedTo(
          deserialized.assignedTo
        )
      : deserialized.assignedTo,
  householdMembers: deserialized.householdMembers.map(
    serializeUpdateApplication_updateApplication_CharityCareApplication_householdMembers
  ),
  documents: deserialized.documents.map(
    serializeUpdateApplication_updateApplication_CharityCareApplication_documents
  ),
  documentFiles: deserialized.documentFiles.map(
    serializeUpdateApplication_updateApplication_CharityCareApplication_documentFiles
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeUpdateApplication_updateApplication_CharityCareApplication_benefitOutcomes
  ),
  accountOnDateOfService:
    deserialized.accountOnDateOfService != null
      ? serializeUpdateApplication_updateApplication_CharityCareApplication_accountOnDateOfService(
          deserialized.accountOnDateOfService
        )
      : deserialized.accountOnDateOfService,
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  dateOfApplication:
    deserialized.dateOfApplication != null
      ? formatISODate(deserialized.dateOfApplication)
      : deserialized.dateOfApplication,
  requestedDateOfApplication:
    deserialized.requestedDateOfApplication != null
      ? formatISODate(deserialized.requestedDateOfApplication)
      : deserialized.requestedDateOfApplication,
})
export interface UpdateApplication_updateApplication_SlideApplication_person_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_person_phoneNumbers_esignSession_esignWizards = (
  serialized: UpdateApplication_updateApplication_SlideApplication_person_phoneNumbers_esignSession_esignWizardsOrig
): UpdateApplication_updateApplication_SlideApplication_person_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeUpdateApplication_updateApplication_SlideApplication_person_phoneNumbers_esignSession_esignWizards = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_person_phoneNumbers_esignSession_esignWizards
): UpdateApplication_updateApplication_SlideApplication_person_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface UpdateApplication_updateApplication_SlideApplication_person_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: UpdateApplication_updateApplication_SlideApplication_person_phoneNumbers_esignSession_esignWizards[]
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_person_phoneNumbers_esignSession = (
  serialized: UpdateApplication_updateApplication_SlideApplication_person_phoneNumbers_esignSessionOrig
): UpdateApplication_updateApplication_SlideApplication_person_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeUpdateApplication_updateApplication_SlideApplication_person_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializeUpdateApplication_updateApplication_SlideApplication_person_phoneNumbers_esignSession = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_person_phoneNumbers_esignSession
): UpdateApplication_updateApplication_SlideApplication_person_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeUpdateApplication_updateApplication_SlideApplication_person_phoneNumbers_esignSession_esignWizards
  ),
})
export interface UpdateApplication_updateApplication_SlideApplication_person_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: UpdateApplication_updateApplication_SlideApplication_person_phoneNumbers_esignSession | null
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_person_phoneNumbers = (
  serialized: UpdateApplication_updateApplication_SlideApplication_person_phoneNumbersOrig
): UpdateApplication_updateApplication_SlideApplication_person_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeUpdateApplication_updateApplication_SlideApplication_person_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeUpdateApplication_updateApplication_SlideApplication_person_phoneNumbers = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_person_phoneNumbers
): UpdateApplication_updateApplication_SlideApplication_person_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeUpdateApplication_updateApplication_SlideApplication_person_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface UpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application_MedicaidApplication = (
  serialized: UpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application_MedicaidApplicationOrig
): UpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application_MedicaidApplication = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application_MedicaidApplication
): UpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application_CharityCareApplication = (
  serialized: UpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application_CharityCareApplicationOrig
): UpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application_CharityCareApplication = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application_CharityCareApplication
): UpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application_SlideApplication = (
  serialized: UpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application_SlideApplicationOrig
): UpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializeUpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application_SlideApplication = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application_SlideApplication
): UpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type UpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application =
  | UpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application_MedicaidApplication
  | UpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application_CharityCareApplication
  | UpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application_SlideApplication
export const deserializeUpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application = (
  serialized: UpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_applicationOrig
): UpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializeUpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeUpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeUpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application'
  )
}
export const serializeUpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application
): UpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializeUpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeUpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeUpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application'
  )
}
export interface UpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: UpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application | null
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes = (
  serialized: UpdateApplication_updateApplication_SlideApplication_person_benefitOutcomesOrig
): UpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializeUpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeUpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes
): UpdateApplication_updateApplication_SlideApplication_person_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializeUpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface UpdateApplication_updateApplication_SlideApplication_person_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_person_incomeSources_esignSession_esignWizards = (
  serialized: UpdateApplication_updateApplication_SlideApplication_person_incomeSources_esignSession_esignWizardsOrig
): UpdateApplication_updateApplication_SlideApplication_person_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeUpdateApplication_updateApplication_SlideApplication_person_incomeSources_esignSession_esignWizards = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_person_incomeSources_esignSession_esignWizards
): UpdateApplication_updateApplication_SlideApplication_person_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface UpdateApplication_updateApplication_SlideApplication_person_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: UpdateApplication_updateApplication_SlideApplication_person_incomeSources_esignSession_esignWizards[]
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_person_incomeSources_esignSession = (
  serialized: UpdateApplication_updateApplication_SlideApplication_person_incomeSources_esignSessionOrig
): UpdateApplication_updateApplication_SlideApplication_person_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeUpdateApplication_updateApplication_SlideApplication_person_incomeSources_esignSession_esignWizards
  ),
})
export const serializeUpdateApplication_updateApplication_SlideApplication_person_incomeSources_esignSession = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_person_incomeSources_esignSession
): UpdateApplication_updateApplication_SlideApplication_person_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeUpdateApplication_updateApplication_SlideApplication_person_incomeSources_esignSession_esignWizards
  ),
})
export interface UpdateApplication_updateApplication_SlideApplication_person_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: UpdateApplication_updateApplication_SlideApplication_person_incomeSources_esignSession | null
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_person_incomeSources = (
  serialized: UpdateApplication_updateApplication_SlideApplication_person_incomeSourcesOrig
): UpdateApplication_updateApplication_SlideApplication_person_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeUpdateApplication_updateApplication_SlideApplication_person_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeUpdateApplication_updateApplication_SlideApplication_person_incomeSources = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_person_incomeSources
): UpdateApplication_updateApplication_SlideApplication_person_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeUpdateApplication_updateApplication_SlideApplication_person_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface UpdateApplication_updateApplication_SlideApplication_person_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_person_deductions = (
  serialized: UpdateApplication_updateApplication_SlideApplication_person_deductionsOrig
): UpdateApplication_updateApplication_SlideApplication_person_deductions => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_SlideApplication_person_deductions = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_person_deductions
): UpdateApplication_updateApplication_SlideApplication_person_deductionsOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards = (
  serialized: UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizardsOrig
): UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards
): UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards[]
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSession = (
  serialized: UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSessionOrig
): UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSession = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSession
): UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards
  ),
})
export interface UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSession | null
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_phoneNumbers = (
  serialized: UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_phoneNumbersOrig
): UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_phoneNumbers = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_phoneNumbers
): UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication = (
  serialized: UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplicationOrig
): UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication
): UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication = (
  serialized: UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplicationOrig
): UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication
): UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication = (
  serialized: UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplicationOrig
): UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication
): UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application =
  | UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication
  | UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication
  | UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication
export const deserializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application = (
  serialized: UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_applicationOrig
): UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application'
  )
}
export const serializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application
): UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application'
  )
}
export interface UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application | null
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes = (
  serialized: UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomesOrig
): UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes
): UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards = (
  serialized: UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizardsOrig
): UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards
): UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards[]
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_incomeSources_esignSession = (
  serialized: UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_incomeSources_esignSessionOrig
): UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards
  ),
})
export const serializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_incomeSources_esignSession = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_incomeSources_esignSession
): UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards
  ),
})
export interface UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_incomeSources_esignSession | null
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_incomeSources = (
  serialized: UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_incomeSourcesOrig
): UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_incomeSources = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_incomeSources
): UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_deductions = (
  serialized: UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_deductionsOrig
): UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_deductions => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_deductions = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_deductions
): UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_deductionsOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes[]
  incomeSources: UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_incomeSources[]
  deductions: UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson = (
  serialized: UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPersonOrig
): UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_deductions
  ),
})
export const serializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson
): UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPersonOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson_deductions
  ),
})
export interface UpdateApplication_updateApplication_SlideApplication_person_relationships {
  __typename: 'Relationship'
  id: string
  relationshipType: string | null
  reverseRelationshipType: string | null
  liveTogether: boolean | null
  otherPerson: UpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_person_relationships = (
  serialized: UpdateApplication_updateApplication_SlideApplication_person_relationshipsOrig
): UpdateApplication_updateApplication_SlideApplication_person_relationships => ({
  ...serialized,
  otherPerson: deserializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson(
    serialized.otherPerson
  ),
})
export const serializeUpdateApplication_updateApplication_SlideApplication_person_relationships = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_person_relationships
): UpdateApplication_updateApplication_SlideApplication_person_relationshipsOrig => ({
  ...deserialized,
  otherPerson: serializeUpdateApplication_updateApplication_SlideApplication_person_relationships_otherPerson(
    deserialized.otherPerson
  ),
})
export interface UpdateApplication_updateApplication_SlideApplication_person_documentFiles {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_person_documentFiles = (
  serialized: UpdateApplication_updateApplication_SlideApplication_person_documentFilesOrig
): UpdateApplication_updateApplication_SlideApplication_person_documentFiles => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializeUpdateApplication_updateApplication_SlideApplication_person_documentFiles = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_person_documentFiles
): UpdateApplication_updateApplication_SlideApplication_person_documentFilesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface UpdateApplication_updateApplication_SlideApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_person_openApplications_MedicaidApplication = (
  serialized: UpdateApplication_updateApplication_SlideApplication_person_openApplications_MedicaidApplicationOrig
): UpdateApplication_updateApplication_SlideApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeUpdateApplication_updateApplication_SlideApplication_person_openApplications_MedicaidApplication = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_person_openApplications_MedicaidApplication
): UpdateApplication_updateApplication_SlideApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface UpdateApplication_updateApplication_SlideApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_person_openApplications_CharityCareApplication = (
  serialized: UpdateApplication_updateApplication_SlideApplication_person_openApplications_CharityCareApplicationOrig
): UpdateApplication_updateApplication_SlideApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeUpdateApplication_updateApplication_SlideApplication_person_openApplications_CharityCareApplication = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_person_openApplications_CharityCareApplication
): UpdateApplication_updateApplication_SlideApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface UpdateApplication_updateApplication_SlideApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_person_openApplications_SlideApplication = (
  serialized: UpdateApplication_updateApplication_SlideApplication_person_openApplications_SlideApplicationOrig
): UpdateApplication_updateApplication_SlideApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeUpdateApplication_updateApplication_SlideApplication_person_openApplications_SlideApplication = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_person_openApplications_SlideApplication
): UpdateApplication_updateApplication_SlideApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface UpdateApplication_updateApplication_SlideApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_person_openApplications_RyanWhiteApplication = (
  serialized: UpdateApplication_updateApplication_SlideApplication_person_openApplications_RyanWhiteApplicationOrig
): UpdateApplication_updateApplication_SlideApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeUpdateApplication_updateApplication_SlideApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_person_openApplications_RyanWhiteApplication
): UpdateApplication_updateApplication_SlideApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type UpdateApplication_updateApplication_SlideApplication_person_openApplications =
  | UpdateApplication_updateApplication_SlideApplication_person_openApplications_MedicaidApplication
  | UpdateApplication_updateApplication_SlideApplication_person_openApplications_CharityCareApplication
  | UpdateApplication_updateApplication_SlideApplication_person_openApplications_SlideApplication
  | UpdateApplication_updateApplication_SlideApplication_person_openApplications_RyanWhiteApplication
export const deserializeUpdateApplication_updateApplication_SlideApplication_person_openApplications = (
  serialized: UpdateApplication_updateApplication_SlideApplication_person_openApplicationsOrig
): UpdateApplication_updateApplication_SlideApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializeUpdateApplication_updateApplication_SlideApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeUpdateApplication_updateApplication_SlideApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeUpdateApplication_updateApplication_SlideApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeUpdateApplication_updateApplication_SlideApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_SlideApplication_person_openApplications'
  )
}
export const serializeUpdateApplication_updateApplication_SlideApplication_person_openApplications = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_person_openApplications
): UpdateApplication_updateApplication_SlideApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializeUpdateApplication_updateApplication_SlideApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeUpdateApplication_updateApplication_SlideApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeUpdateApplication_updateApplication_SlideApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeUpdateApplication_updateApplication_SlideApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_SlideApplication_person_openApplications'
  )
}
export interface UpdateApplication_updateApplication_SlideApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_person_openHouseholdMemberApplications = (
  serialized: UpdateApplication_updateApplication_SlideApplication_person_openHouseholdMemberApplicationsOrig
): UpdateApplication_updateApplication_SlideApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeUpdateApplication_updateApplication_SlideApplication_person_openHouseholdMemberApplications = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_person_openHouseholdMemberApplications
): UpdateApplication_updateApplication_SlideApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface UpdateApplication_updateApplication_SlideApplication_person {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: UpdateApplication_updateApplication_SlideApplication_person_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: UpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes[]
  incomeSources: UpdateApplication_updateApplication_SlideApplication_person_incomeSources[]
  deductions: UpdateApplication_updateApplication_SlideApplication_person_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
  relationships: UpdateApplication_updateApplication_SlideApplication_person_relationships[]
  documentFiles: UpdateApplication_updateApplication_SlideApplication_person_documentFiles[]
  openApplications: UpdateApplication_updateApplication_SlideApplication_person_openApplications[]
  openHouseholdMemberApplications: UpdateApplication_updateApplication_SlideApplication_person_openHouseholdMemberApplications[]
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_person = (
  serialized: UpdateApplication_updateApplication_SlideApplication_personOrig
): UpdateApplication_updateApplication_SlideApplication_person => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeUpdateApplication_updateApplication_SlideApplication_person_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeUpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeUpdateApplication_updateApplication_SlideApplication_person_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeUpdateApplication_updateApplication_SlideApplication_person_deductions
  ),
  relationships: serialized.relationships.map(
    deserializeUpdateApplication_updateApplication_SlideApplication_person_relationships
  ),
  documentFiles: serialized.documentFiles.map(
    deserializeUpdateApplication_updateApplication_SlideApplication_person_documentFiles
  ),
  openApplications: serialized.openApplications.map(
    deserializeUpdateApplication_updateApplication_SlideApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializeUpdateApplication_updateApplication_SlideApplication_person_openHouseholdMemberApplications
  ),
})
export const serializeUpdateApplication_updateApplication_SlideApplication_person = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_person
): UpdateApplication_updateApplication_SlideApplication_personOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeUpdateApplication_updateApplication_SlideApplication_person_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeUpdateApplication_updateApplication_SlideApplication_person_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeUpdateApplication_updateApplication_SlideApplication_person_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeUpdateApplication_updateApplication_SlideApplication_person_deductions
  ),
  relationships: deserialized.relationships.map(
    serializeUpdateApplication_updateApplication_SlideApplication_person_relationships
  ),
  documentFiles: deserialized.documentFiles.map(
    serializeUpdateApplication_updateApplication_SlideApplication_person_documentFiles
  ),
  openApplications: deserialized.openApplications.map(
    serializeUpdateApplication_updateApplication_SlideApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializeUpdateApplication_updateApplication_SlideApplication_person_openHouseholdMemberApplications
  ),
})
export interface UpdateApplication_updateApplication_SlideApplication_assignedTo {
  __typename: 'User'
  id: string
  email: string
  name: string | null
  isCurrentUser: boolean
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_assignedTo = (
  serialized: UpdateApplication_updateApplication_SlideApplication_assignedToOrig
): UpdateApplication_updateApplication_SlideApplication_assignedTo => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_SlideApplication_assignedTo = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_assignedTo
): UpdateApplication_updateApplication_SlideApplication_assignedToOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_SlideApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards = (
  serialized: UpdateApplication_updateApplication_SlideApplication_householdMembers_person_phoneNumbers_esignSession_esignWizardsOrig
): UpdateApplication_updateApplication_SlideApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards
): UpdateApplication_updateApplication_SlideApplication_householdMembers_person_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface UpdateApplication_updateApplication_SlideApplication_householdMembers_person_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: UpdateApplication_updateApplication_SlideApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards[]
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_phoneNumbers_esignSession = (
  serialized: UpdateApplication_updateApplication_SlideApplication_householdMembers_person_phoneNumbers_esignSessionOrig
): UpdateApplication_updateApplication_SlideApplication_householdMembers_person_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_phoneNumbers_esignSession = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_householdMembers_person_phoneNumbers_esignSession
): UpdateApplication_updateApplication_SlideApplication_householdMembers_person_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards
  ),
})
export interface UpdateApplication_updateApplication_SlideApplication_householdMembers_person_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: UpdateApplication_updateApplication_SlideApplication_householdMembers_person_phoneNumbers_esignSession | null
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_phoneNumbers = (
  serialized: UpdateApplication_updateApplication_SlideApplication_householdMembers_person_phoneNumbersOrig
): UpdateApplication_updateApplication_SlideApplication_householdMembers_person_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_phoneNumbers = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_householdMembers_person_phoneNumbers
): UpdateApplication_updateApplication_SlideApplication_householdMembers_person_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface UpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication = (
  serialized: UpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplicationOrig
): UpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication
): UpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication = (
  serialized: UpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplicationOrig
): UpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication
): UpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application_SlideApplication = (
  serialized: UpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application_SlideApplicationOrig
): UpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application_SlideApplication = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application_SlideApplication
): UpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type UpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application =
  | UpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication
  | UpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication
  | UpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application_SlideApplication
export const deserializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application = (
  serialized: UpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_applicationOrig
): UpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application'
  )
}
export const serializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application
): UpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application'
  )
}
export interface UpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: UpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application | null
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes = (
  serialized: UpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomesOrig
): UpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes
): UpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface UpdateApplication_updateApplication_SlideApplication_householdMembers_person_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_incomeSources_esignSession_esignWizards = (
  serialized: UpdateApplication_updateApplication_SlideApplication_householdMembers_person_incomeSources_esignSession_esignWizardsOrig
): UpdateApplication_updateApplication_SlideApplication_householdMembers_person_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_incomeSources_esignSession_esignWizards = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_householdMembers_person_incomeSources_esignSession_esignWizards
): UpdateApplication_updateApplication_SlideApplication_householdMembers_person_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface UpdateApplication_updateApplication_SlideApplication_householdMembers_person_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: UpdateApplication_updateApplication_SlideApplication_householdMembers_person_incomeSources_esignSession_esignWizards[]
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_incomeSources_esignSession = (
  serialized: UpdateApplication_updateApplication_SlideApplication_householdMembers_person_incomeSources_esignSessionOrig
): UpdateApplication_updateApplication_SlideApplication_householdMembers_person_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_incomeSources_esignSession_esignWizards
  ),
})
export const serializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_incomeSources_esignSession = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_householdMembers_person_incomeSources_esignSession
): UpdateApplication_updateApplication_SlideApplication_householdMembers_person_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_incomeSources_esignSession_esignWizards
  ),
})
export interface UpdateApplication_updateApplication_SlideApplication_householdMembers_person_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: UpdateApplication_updateApplication_SlideApplication_householdMembers_person_incomeSources_esignSession | null
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_incomeSources = (
  serialized: UpdateApplication_updateApplication_SlideApplication_householdMembers_person_incomeSourcesOrig
): UpdateApplication_updateApplication_SlideApplication_householdMembers_person_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_incomeSources = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_householdMembers_person_incomeSources
): UpdateApplication_updateApplication_SlideApplication_householdMembers_person_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface UpdateApplication_updateApplication_SlideApplication_householdMembers_person_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_deductions = (
  serialized: UpdateApplication_updateApplication_SlideApplication_householdMembers_person_deductionsOrig
): UpdateApplication_updateApplication_SlideApplication_householdMembers_person_deductions => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_deductions = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_householdMembers_person_deductions
): UpdateApplication_updateApplication_SlideApplication_householdMembers_person_deductionsOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_SlideApplication_householdMembers_person_documentFiles {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_documentFiles = (
  serialized: UpdateApplication_updateApplication_SlideApplication_householdMembers_person_documentFilesOrig
): UpdateApplication_updateApplication_SlideApplication_householdMembers_person_documentFiles => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_documentFiles = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_householdMembers_person_documentFiles
): UpdateApplication_updateApplication_SlideApplication_householdMembers_person_documentFilesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface UpdateApplication_updateApplication_SlideApplication_householdMembers_person {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: UpdateApplication_updateApplication_SlideApplication_householdMembers_person_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: UpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes[]
  incomeSources: UpdateApplication_updateApplication_SlideApplication_householdMembers_person_incomeSources[]
  deductions: UpdateApplication_updateApplication_SlideApplication_householdMembers_person_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
  documentFiles: UpdateApplication_updateApplication_SlideApplication_householdMembers_person_documentFiles[]
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person = (
  serialized: UpdateApplication_updateApplication_SlideApplication_householdMembers_personOrig
): UpdateApplication_updateApplication_SlideApplication_householdMembers_person => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_deductions
  ),
  documentFiles: serialized.documentFiles.map(
    deserializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_documentFiles
  ),
})
export const serializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_householdMembers_person
): UpdateApplication_updateApplication_SlideApplication_householdMembers_personOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_deductions
  ),
  documentFiles: deserialized.documentFiles.map(
    serializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person_documentFiles
  ),
})
export interface UpdateApplication_updateApplication_SlideApplication_householdMembers {
  __typename: 'ApplicationHouseholdMember'
  id: string
  wantsCoverage: boolean | null
  person: UpdateApplication_updateApplication_SlideApplication_householdMembers_person
  createdAt: Date
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_householdMembers = (
  serialized: UpdateApplication_updateApplication_SlideApplication_householdMembersOrig
): UpdateApplication_updateApplication_SlideApplication_householdMembers => ({
  ...serialized,
  person: deserializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person(
    serialized.person
  ),
  createdAt: parseDate(serialized.createdAt),
})
export const serializeUpdateApplication_updateApplication_SlideApplication_householdMembers = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_householdMembers
): UpdateApplication_updateApplication_SlideApplication_householdMembersOrig => ({
  ...deserialized,
  person: serializeUpdateApplication_updateApplication_SlideApplication_householdMembers_person(
    deserialized.person
  ),
  createdAt: formatISO(deserialized.createdAt),
})
export interface UpdateApplication_updateApplication_SlideApplication_documents_files {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_documents_files = (
  serialized: UpdateApplication_updateApplication_SlideApplication_documents_filesOrig
): UpdateApplication_updateApplication_SlideApplication_documents_files => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializeUpdateApplication_updateApplication_SlideApplication_documents_files = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_documents_files
): UpdateApplication_updateApplication_SlideApplication_documents_filesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface UpdateApplication_updateApplication_SlideApplication_documents_person {
  __typename: 'Person'
  id: string
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_documents_person = (
  serialized: UpdateApplication_updateApplication_SlideApplication_documents_personOrig
): UpdateApplication_updateApplication_SlideApplication_documents_person => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_SlideApplication_documents_person = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_documents_person
): UpdateApplication_updateApplication_SlideApplication_documents_personOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_SlideApplication_documents_application {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_documents_application = (
  serialized: UpdateApplication_updateApplication_SlideApplication_documents_applicationOrig
): UpdateApplication_updateApplication_SlideApplication_documents_application => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_SlideApplication_documents_application = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_documents_application
): UpdateApplication_updateApplication_SlideApplication_documents_applicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_SlideApplication_documents {
  __typename: 'Document'
  id: string
  documentType: string
  complete: boolean | null
  files: UpdateApplication_updateApplication_SlideApplication_documents_files[]
  updatedAt: Date
  notes: string | null
  person: UpdateApplication_updateApplication_SlideApplication_documents_person | null
  application: UpdateApplication_updateApplication_SlideApplication_documents_application
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_documents = (
  serialized: UpdateApplication_updateApplication_SlideApplication_documentsOrig
): UpdateApplication_updateApplication_SlideApplication_documents => ({
  ...serialized,
  files: serialized.files.map(
    deserializeUpdateApplication_updateApplication_SlideApplication_documents_files
  ),
  updatedAt: parseDate(serialized.updatedAt),
  person:
    serialized.person != null
      ? deserializeUpdateApplication_updateApplication_SlideApplication_documents_person(
          serialized.person
        )
      : serialized.person,
  application: deserializeUpdateApplication_updateApplication_SlideApplication_documents_application(
    serialized.application
  ),
})
export const serializeUpdateApplication_updateApplication_SlideApplication_documents = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_documents
): UpdateApplication_updateApplication_SlideApplication_documentsOrig => ({
  ...deserialized,
  files: deserialized.files.map(
    serializeUpdateApplication_updateApplication_SlideApplication_documents_files
  ),
  updatedAt: formatISO(deserialized.updatedAt),
  person:
    deserialized.person != null
      ? serializeUpdateApplication_updateApplication_SlideApplication_documents_person(
          deserialized.person
        )
      : deserialized.person,
  application: serializeUpdateApplication_updateApplication_SlideApplication_documents_application(
    deserialized.application
  ),
})
export interface UpdateApplication_updateApplication_SlideApplication_documentFiles_documents {
  __typename: 'Document'
  id: string
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_documentFiles_documents = (
  serialized: UpdateApplication_updateApplication_SlideApplication_documentFiles_documentsOrig
): UpdateApplication_updateApplication_SlideApplication_documentFiles_documents => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_SlideApplication_documentFiles_documents = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_documentFiles_documents
): UpdateApplication_updateApplication_SlideApplication_documentFiles_documentsOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_SlideApplication_documentFiles {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
  documents: UpdateApplication_updateApplication_SlideApplication_documentFiles_documents[]
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_documentFiles = (
  serialized: UpdateApplication_updateApplication_SlideApplication_documentFilesOrig
): UpdateApplication_updateApplication_SlideApplication_documentFiles => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
  documents: serialized.documents.map(
    deserializeUpdateApplication_updateApplication_SlideApplication_documentFiles_documents
  ),
})
export const serializeUpdateApplication_updateApplication_SlideApplication_documentFiles = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_documentFiles
): UpdateApplication_updateApplication_SlideApplication_documentFilesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
  documents: deserialized.documents.map(
    serializeUpdateApplication_updateApplication_SlideApplication_documentFiles_documents
  ),
})
export interface UpdateApplication_updateApplication_SlideApplication_benefitOutcomes_person {
  __typename: 'Person'
  id: string
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_benefitOutcomes_person = (
  serialized: UpdateApplication_updateApplication_SlideApplication_benefitOutcomes_personOrig
): UpdateApplication_updateApplication_SlideApplication_benefitOutcomes_person => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_SlideApplication_benefitOutcomes_person = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_benefitOutcomes_person
): UpdateApplication_updateApplication_SlideApplication_benefitOutcomes_personOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_SlideApplication_benefitOutcomes_application {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_benefitOutcomes_application = (
  serialized: UpdateApplication_updateApplication_SlideApplication_benefitOutcomes_applicationOrig
): UpdateApplication_updateApplication_SlideApplication_benefitOutcomes_application => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_SlideApplication_benefitOutcomes_application = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_benefitOutcomes_application
): UpdateApplication_updateApplication_SlideApplication_benefitOutcomes_applicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_SlideApplication_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  person: UpdateApplication_updateApplication_SlideApplication_benefitOutcomes_person
  application: UpdateApplication_updateApplication_SlideApplication_benefitOutcomes_application | null
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_benefitOutcomes = (
  serialized: UpdateApplication_updateApplication_SlideApplication_benefitOutcomesOrig
): UpdateApplication_updateApplication_SlideApplication_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  person: deserializeUpdateApplication_updateApplication_SlideApplication_benefitOutcomes_person(
    serialized.person
  ),
  application:
    serialized.application != null
      ? deserializeUpdateApplication_updateApplication_SlideApplication_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeUpdateApplication_updateApplication_SlideApplication_benefitOutcomes = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_benefitOutcomes
): UpdateApplication_updateApplication_SlideApplication_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  person: serializeUpdateApplication_updateApplication_SlideApplication_benefitOutcomes_person(
    deserialized.person
  ),
  application:
    deserialized.application != null
      ? serializeUpdateApplication_updateApplication_SlideApplication_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface UpdateApplication_updateApplication_SlideApplication_accountOnDateOfService {
  __typename: 'Account'
  id: string
  hospitalAccountId: string | null
  dateOfService: Date
  timeOfService: string | null
  serviceTimeZone: string
  facility: string
  department: string
  location: string | null
  insuranceType: string
  status: string
  createdAt: Date
  updatedAt: Date
  notes: string | null
  accountAmount: number | null
  njmmisCheck: string | null
  previousInsurance: string | null
  invoiceMonth: string | null
  invoiceYear: string | null
  dischargeDate: Date | null
  isScheduled: boolean
}
export const deserializeUpdateApplication_updateApplication_SlideApplication_accountOnDateOfService = (
  serialized: UpdateApplication_updateApplication_SlideApplication_accountOnDateOfServiceOrig
): UpdateApplication_updateApplication_SlideApplication_accountOnDateOfService => ({
  ...serialized,
  dateOfService: parseDate(serialized.dateOfService),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  njmmisCheck:
    serialized.njmmisCheck != null
      ? deserializeNjmmisCheckResult(serialized.njmmisCheck)
      : serialized.njmmisCheck,
  dischargeDate:
    serialized.dischargeDate != null
      ? parseDate(serialized.dischargeDate)
      : serialized.dischargeDate,
})
export const serializeUpdateApplication_updateApplication_SlideApplication_accountOnDateOfService = (
  deserialized: UpdateApplication_updateApplication_SlideApplication_accountOnDateOfService
): UpdateApplication_updateApplication_SlideApplication_accountOnDateOfServiceOrig => ({
  ...deserialized,
  dateOfService: formatISODate(deserialized.dateOfService),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  njmmisCheck:
    deserialized.njmmisCheck != null
      ? serializeNjmmisCheckResult(deserialized.njmmisCheck)
      : deserialized.njmmisCheck,
  dischargeDate:
    deserialized.dischargeDate != null
      ? formatISODate(deserialized.dischargeDate)
      : deserialized.dischargeDate,
})
export interface UpdateApplication_updateApplication_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  person: UpdateApplication_updateApplication_SlideApplication_person
  assignedTo: UpdateApplication_updateApplication_SlideApplication_assignedTo | null
  householdMembers: UpdateApplication_updateApplication_SlideApplication_householdMembers[]
  documents: UpdateApplication_updateApplication_SlideApplication_documents[]
  documentFiles: UpdateApplication_updateApplication_SlideApplication_documentFiles[]
  benefitOutcomes: UpdateApplication_updateApplication_SlideApplication_benefitOutcomes[]
  accountOnDateOfService: UpdateApplication_updateApplication_SlideApplication_accountOnDateOfService | null
  initialDateOfService: Date | null
  receivedDate: Date | null
  notes: string | null
  facility: string
  slideType: string
  dateOfApplication: Date | null
  coveragePeriod: number | null
}
export const deserializeUpdateApplication_updateApplication_SlideApplication = (
  serialized: UpdateApplication_updateApplication_SlideApplicationOrig
): UpdateApplication_updateApplication_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  person: deserializeUpdateApplication_updateApplication_SlideApplication_person(
    serialized.person
  ),
  assignedTo:
    serialized.assignedTo != null
      ? deserializeUpdateApplication_updateApplication_SlideApplication_assignedTo(
          serialized.assignedTo
        )
      : serialized.assignedTo,
  householdMembers: serialized.householdMembers.map(
    deserializeUpdateApplication_updateApplication_SlideApplication_householdMembers
  ),
  documents: serialized.documents.map(
    deserializeUpdateApplication_updateApplication_SlideApplication_documents
  ),
  documentFiles: serialized.documentFiles.map(
    deserializeUpdateApplication_updateApplication_SlideApplication_documentFiles
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeUpdateApplication_updateApplication_SlideApplication_benefitOutcomes
  ),
  accountOnDateOfService:
    serialized.accountOnDateOfService != null
      ? deserializeUpdateApplication_updateApplication_SlideApplication_accountOnDateOfService(
          serialized.accountOnDateOfService
        )
      : serialized.accountOnDateOfService,
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  receivedDate:
    serialized.receivedDate != null
      ? parseDate(serialized.receivedDate)
      : serialized.receivedDate,
  slideType: deserializeSlideType(serialized.slideType),
  dateOfApplication:
    serialized.dateOfApplication != null
      ? parseDate(serialized.dateOfApplication)
      : serialized.dateOfApplication,
})
export const serializeUpdateApplication_updateApplication_SlideApplication = (
  deserialized: UpdateApplication_updateApplication_SlideApplication
): UpdateApplication_updateApplication_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  person: serializeUpdateApplication_updateApplication_SlideApplication_person(
    deserialized.person
  ),
  assignedTo:
    deserialized.assignedTo != null
      ? serializeUpdateApplication_updateApplication_SlideApplication_assignedTo(
          deserialized.assignedTo
        )
      : deserialized.assignedTo,
  householdMembers: deserialized.householdMembers.map(
    serializeUpdateApplication_updateApplication_SlideApplication_householdMembers
  ),
  documents: deserialized.documents.map(
    serializeUpdateApplication_updateApplication_SlideApplication_documents
  ),
  documentFiles: deserialized.documentFiles.map(
    serializeUpdateApplication_updateApplication_SlideApplication_documentFiles
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeUpdateApplication_updateApplication_SlideApplication_benefitOutcomes
  ),
  accountOnDateOfService:
    deserialized.accountOnDateOfService != null
      ? serializeUpdateApplication_updateApplication_SlideApplication_accountOnDateOfService(
          deserialized.accountOnDateOfService
        )
      : deserialized.accountOnDateOfService,
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  receivedDate:
    deserialized.receivedDate != null
      ? formatISODate(deserialized.receivedDate)
      : deserialized.receivedDate,
  slideType: serializeSlideType(deserialized.slideType),
  dateOfApplication:
    deserialized.dateOfApplication != null
      ? formatISODate(deserialized.dateOfApplication)
      : deserialized.dateOfApplication,
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizards = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizardsOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizards = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizards
): UpdateApplication_updateApplication_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_person_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: UpdateApplication_updateApplication_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizards[]
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_phoneNumbers_esignSession = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_phoneNumbers_esignSessionOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_person_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_phoneNumbers_esignSession = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_phoneNumbers_esignSession
): UpdateApplication_updateApplication_RyanWhiteApplication_person_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizards
  ),
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_person_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: UpdateApplication_updateApplication_RyanWhiteApplication_person_phoneNumbers_esignSession | null
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_phoneNumbers = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_phoneNumbersOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_person_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_phoneNumbers = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_phoneNumbers
): UpdateApplication_updateApplication_RyanWhiteApplication_person_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplication = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplicationOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplication = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplication
): UpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplication = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplicationOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplication = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplication
): UpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplication = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplicationOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplication = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplication
): UpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type UpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application =
  | UpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplication
  | UpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplication
  | UpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplication
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_applicationOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application'
  )
}
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application
): UpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application'
  )
}
export interface UpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: UpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application | null
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomesOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes
): UpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_person_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_incomeSources_esignSession_esignWizards = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_incomeSources_esignSession_esignWizardsOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_person_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_incomeSources_esignSession_esignWizards = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_incomeSources_esignSession_esignWizards
): UpdateApplication_updateApplication_RyanWhiteApplication_person_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_person_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: UpdateApplication_updateApplication_RyanWhiteApplication_person_incomeSources_esignSession_esignWizards[]
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_incomeSources_esignSession = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_incomeSources_esignSessionOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_person_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_incomeSources_esignSession_esignWizards
  ),
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_incomeSources_esignSession = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_incomeSources_esignSession
): UpdateApplication_updateApplication_RyanWhiteApplication_person_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_incomeSources_esignSession_esignWizards
  ),
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_person_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: UpdateApplication_updateApplication_RyanWhiteApplication_person_incomeSources_esignSession | null
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_incomeSources = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_incomeSourcesOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_person_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_incomeSources = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_incomeSources
): UpdateApplication_updateApplication_RyanWhiteApplication_person_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_person_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_deductions = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_deductionsOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_person_deductions => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_deductions = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_deductions
): UpdateApplication_updateApplication_RyanWhiteApplication_person_deductionsOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizardsOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards
): UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards[]
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSession = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSessionOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSession = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSession
): UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards
  ),
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSession | null
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbersOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers
): UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplicationOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication
): UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplicationOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication
): UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplicationOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication
): UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application =
  | UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication
  | UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication
  | UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_applicationOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application'
  )
}
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application
): UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application'
  )
}
export interface UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application | null
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomesOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes
): UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizardsOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards
): UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards[]
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSession = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSessionOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards
  ),
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSession = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSession
): UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards
  ),
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSession | null
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_incomeSources = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_incomeSourcesOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_incomeSources = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_incomeSources
): UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_deductions = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_deductionsOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_deductions => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_deductions = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_deductions
): UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_deductionsOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes[]
  incomeSources: UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_incomeSources[]
  deductions: UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPersonOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_deductions
  ),
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson
): UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPersonOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson_deductions
  ),
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships {
  __typename: 'Relationship'
  id: string
  relationshipType: string | null
  reverseRelationshipType: string | null
  liveTogether: boolean | null
  otherPerson: UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_relationshipsOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships => ({
  ...serialized,
  otherPerson: deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson(
    serialized.otherPerson
  ),
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships
): UpdateApplication_updateApplication_RyanWhiteApplication_person_relationshipsOrig => ({
  ...deserialized,
  otherPerson: serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships_otherPerson(
    deserialized.otherPerson
  ),
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_person_documentFiles {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_documentFiles = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_documentFilesOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_person_documentFiles => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_documentFiles = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_documentFiles
): UpdateApplication_updateApplication_RyanWhiteApplication_person_documentFilesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_MedicaidApplication = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_MedicaidApplicationOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_MedicaidApplication = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_MedicaidApplication
): UpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_CharityCareApplication = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_CharityCareApplicationOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_CharityCareApplication = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_CharityCareApplication
): UpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_SlideApplication = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_SlideApplicationOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_SlideApplication = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_SlideApplication
): UpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_RyanWhiteApplication = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_RyanWhiteApplicationOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_RyanWhiteApplication
): UpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type UpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications =
  | UpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_MedicaidApplication
  | UpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_CharityCareApplication
  | UpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_SlideApplication
  | UpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_RyanWhiteApplication
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_openApplicationsOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications'
  )
}
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications
): UpdateApplication_updateApplication_RyanWhiteApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications'
  )
}
export interface UpdateApplication_updateApplication_RyanWhiteApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_openHouseholdMemberApplications = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_openHouseholdMemberApplicationsOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_openHouseholdMemberApplications = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_person_openHouseholdMemberApplications
): UpdateApplication_updateApplication_RyanWhiteApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_person {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: UpdateApplication_updateApplication_RyanWhiteApplication_person_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: UpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes[]
  incomeSources: UpdateApplication_updateApplication_RyanWhiteApplication_person_incomeSources[]
  deductions: UpdateApplication_updateApplication_RyanWhiteApplication_person_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
  relationships: UpdateApplication_updateApplication_RyanWhiteApplication_person_relationships[]
  documentFiles: UpdateApplication_updateApplication_RyanWhiteApplication_person_documentFiles[]
  openApplications: UpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications[]
  openHouseholdMemberApplications: UpdateApplication_updateApplication_RyanWhiteApplication_person_openHouseholdMemberApplications[]
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_personOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_person => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_deductions
  ),
  relationships: serialized.relationships.map(
    deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships
  ),
  documentFiles: serialized.documentFiles.map(
    deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_documentFiles
  ),
  openApplications: serialized.openApplications.map(
    deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person_openHouseholdMemberApplications
  ),
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_person = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_person
): UpdateApplication_updateApplication_RyanWhiteApplication_personOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_deductions
  ),
  relationships: deserialized.relationships.map(
    serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_relationships
  ),
  documentFiles: deserialized.documentFiles.map(
    serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_documentFiles
  ),
  openApplications: deserialized.openApplications.map(
    serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializeUpdateApplication_updateApplication_RyanWhiteApplication_person_openHouseholdMemberApplications
  ),
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_assignedTo {
  __typename: 'User'
  id: string
  email: string
  name: string | null
  isCurrentUser: boolean
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_assignedTo = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_assignedToOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_assignedTo => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_assignedTo = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_assignedTo
): UpdateApplication_updateApplication_RyanWhiteApplication_assignedToOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSession_esignWizardsOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards
): UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards[]
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSession = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSessionOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSession = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSession
): UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards
  ),
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSession | null
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_phoneNumbers = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_phoneNumbersOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_phoneNumbers = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_phoneNumbers
): UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplicationOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication
): UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplicationOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication
): UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_SlideApplication = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_SlideApplicationOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_SlideApplication = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_SlideApplication
): UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application =
  | UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication
  | UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication
  | UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_SlideApplication
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_applicationOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application'
  )
}
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application
): UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application'
  )
}
export interface UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application | null
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomesOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes
): UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_incomeSources_esignSession_esignWizards = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_incomeSources_esignSession_esignWizardsOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_incomeSources_esignSession_esignWizards = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_incomeSources_esignSession_esignWizards
): UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_incomeSources_esignSession_esignWizards[]
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_incomeSources_esignSession = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_incomeSources_esignSessionOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_incomeSources_esignSession_esignWizards
  ),
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_incomeSources_esignSession = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_incomeSources_esignSession
): UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_incomeSources_esignSession_esignWizards
  ),
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_incomeSources_esignSession | null
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_incomeSources = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_incomeSourcesOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_incomeSources = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_incomeSources
): UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_deductions = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_deductionsOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_deductions => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_deductions = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_deductions
): UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_deductionsOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_documentFiles {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_documentFiles = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_documentFilesOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_documentFiles => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_documentFiles = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_documentFiles
): UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_documentFilesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes[]
  incomeSources: UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_incomeSources[]
  deductions: UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
  documentFiles: UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_documentFiles[]
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_personOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_deductions
  ),
  documentFiles: serialized.documentFiles.map(
    deserializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_documentFiles
  ),
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person
): UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_personOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_deductions
  ),
  documentFiles: deserialized.documentFiles.map(
    serializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person_documentFiles
  ),
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers {
  __typename: 'ApplicationHouseholdMember'
  id: string
  wantsCoverage: boolean | null
  person: UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person
  createdAt: Date
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_householdMembersOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers => ({
  ...serialized,
  person: deserializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person(
    serialized.person
  ),
  createdAt: parseDate(serialized.createdAt),
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers
): UpdateApplication_updateApplication_RyanWhiteApplication_householdMembersOrig => ({
  ...deserialized,
  person: serializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers_person(
    deserialized.person
  ),
  createdAt: formatISO(deserialized.createdAt),
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_documents_files {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_documents_files = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_documents_filesOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_documents_files => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_documents_files = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_documents_files
): UpdateApplication_updateApplication_RyanWhiteApplication_documents_filesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_documents_person {
  __typename: 'Person'
  id: string
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_documents_person = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_documents_personOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_documents_person => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_documents_person = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_documents_person
): UpdateApplication_updateApplication_RyanWhiteApplication_documents_personOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_documents_application {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_documents_application = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_documents_applicationOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_documents_application => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_documents_application = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_documents_application
): UpdateApplication_updateApplication_RyanWhiteApplication_documents_applicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_documents {
  __typename: 'Document'
  id: string
  documentType: string
  complete: boolean | null
  files: UpdateApplication_updateApplication_RyanWhiteApplication_documents_files[]
  updatedAt: Date
  notes: string | null
  person: UpdateApplication_updateApplication_RyanWhiteApplication_documents_person | null
  application: UpdateApplication_updateApplication_RyanWhiteApplication_documents_application
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_documents = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_documentsOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_documents => ({
  ...serialized,
  files: serialized.files.map(
    deserializeUpdateApplication_updateApplication_RyanWhiteApplication_documents_files
  ),
  updatedAt: parseDate(serialized.updatedAt),
  person:
    serialized.person != null
      ? deserializeUpdateApplication_updateApplication_RyanWhiteApplication_documents_person(
          serialized.person
        )
      : serialized.person,
  application: deserializeUpdateApplication_updateApplication_RyanWhiteApplication_documents_application(
    serialized.application
  ),
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_documents = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_documents
): UpdateApplication_updateApplication_RyanWhiteApplication_documentsOrig => ({
  ...deserialized,
  files: deserialized.files.map(
    serializeUpdateApplication_updateApplication_RyanWhiteApplication_documents_files
  ),
  updatedAt: formatISO(deserialized.updatedAt),
  person:
    deserialized.person != null
      ? serializeUpdateApplication_updateApplication_RyanWhiteApplication_documents_person(
          deserialized.person
        )
      : deserialized.person,
  application: serializeUpdateApplication_updateApplication_RyanWhiteApplication_documents_application(
    deserialized.application
  ),
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_documentFiles_documents {
  __typename: 'Document'
  id: string
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_documentFiles_documents = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_documentFiles_documentsOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_documentFiles_documents => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_documentFiles_documents = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_documentFiles_documents
): UpdateApplication_updateApplication_RyanWhiteApplication_documentFiles_documentsOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_documentFiles {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
  documents: UpdateApplication_updateApplication_RyanWhiteApplication_documentFiles_documents[]
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_documentFiles = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_documentFilesOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_documentFiles => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
  documents: serialized.documents.map(
    deserializeUpdateApplication_updateApplication_RyanWhiteApplication_documentFiles_documents
  ),
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_documentFiles = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_documentFiles
): UpdateApplication_updateApplication_RyanWhiteApplication_documentFilesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
  documents: deserialized.documents.map(
    serializeUpdateApplication_updateApplication_RyanWhiteApplication_documentFiles_documents
  ),
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_benefitOutcomes_person {
  __typename: 'Person'
  id: string
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_benefitOutcomes_person = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_benefitOutcomes_personOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_benefitOutcomes_person => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_benefitOutcomes_person = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_benefitOutcomes_person
): UpdateApplication_updateApplication_RyanWhiteApplication_benefitOutcomes_personOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_benefitOutcomes_application {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_benefitOutcomes_application = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_benefitOutcomes_applicationOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_benefitOutcomes_application => ({
  ...serialized,
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_benefitOutcomes_application = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_benefitOutcomes_application
): UpdateApplication_updateApplication_RyanWhiteApplication_benefitOutcomes_applicationOrig => ({
  ...deserialized,
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  person: UpdateApplication_updateApplication_RyanWhiteApplication_benefitOutcomes_person
  application: UpdateApplication_updateApplication_RyanWhiteApplication_benefitOutcomes_application | null
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_benefitOutcomes = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_benefitOutcomesOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  person: deserializeUpdateApplication_updateApplication_RyanWhiteApplication_benefitOutcomes_person(
    serialized.person
  ),
  application:
    serialized.application != null
      ? deserializeUpdateApplication_updateApplication_RyanWhiteApplication_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_benefitOutcomes = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_benefitOutcomes
): UpdateApplication_updateApplication_RyanWhiteApplication_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  person: serializeUpdateApplication_updateApplication_RyanWhiteApplication_benefitOutcomes_person(
    deserialized.person
  ),
  application:
    deserialized.application != null
      ? serializeUpdateApplication_updateApplication_RyanWhiteApplication_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication_accountOnDateOfService {
  __typename: 'Account'
  id: string
  hospitalAccountId: string | null
  dateOfService: Date
  timeOfService: string | null
  serviceTimeZone: string
  facility: string
  department: string
  location: string | null
  insuranceType: string
  status: string
  createdAt: Date
  updatedAt: Date
  notes: string | null
  accountAmount: number | null
  njmmisCheck: string | null
  previousInsurance: string | null
  invoiceMonth: string | null
  invoiceYear: string | null
  dischargeDate: Date | null
  isScheduled: boolean
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication_accountOnDateOfService = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplication_accountOnDateOfServiceOrig
): UpdateApplication_updateApplication_RyanWhiteApplication_accountOnDateOfService => ({
  ...serialized,
  dateOfService: parseDate(serialized.dateOfService),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  njmmisCheck:
    serialized.njmmisCheck != null
      ? deserializeNjmmisCheckResult(serialized.njmmisCheck)
      : serialized.njmmisCheck,
  dischargeDate:
    serialized.dischargeDate != null
      ? parseDate(serialized.dischargeDate)
      : serialized.dischargeDate,
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication_accountOnDateOfService = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication_accountOnDateOfService
): UpdateApplication_updateApplication_RyanWhiteApplication_accountOnDateOfServiceOrig => ({
  ...deserialized,
  dateOfService: formatISODate(deserialized.dateOfService),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  njmmisCheck:
    deserialized.njmmisCheck != null
      ? serializeNjmmisCheckResult(deserialized.njmmisCheck)
      : deserialized.njmmisCheck,
  dischargeDate:
    deserialized.dischargeDate != null
      ? formatISODate(deserialized.dischargeDate)
      : deserialized.dischargeDate,
})
export interface UpdateApplication_updateApplication_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  person: UpdateApplication_updateApplication_RyanWhiteApplication_person
  assignedTo: UpdateApplication_updateApplication_RyanWhiteApplication_assignedTo | null
  householdMembers: UpdateApplication_updateApplication_RyanWhiteApplication_householdMembers[]
  documents: UpdateApplication_updateApplication_RyanWhiteApplication_documents[]
  documentFiles: UpdateApplication_updateApplication_RyanWhiteApplication_documentFiles[]
  benefitOutcomes: UpdateApplication_updateApplication_RyanWhiteApplication_benefitOutcomes[]
  accountOnDateOfService: UpdateApplication_updateApplication_RyanWhiteApplication_accountOnDateOfService | null
  initialDateOfService: Date | null
  receivedDate: Date | null
  notes: string | null
  facility: string
  dateOfApplication: Date | null
  coveragePeriod: number | null
}
export const deserializeUpdateApplication_updateApplication_RyanWhiteApplication = (
  serialized: UpdateApplication_updateApplication_RyanWhiteApplicationOrig
): UpdateApplication_updateApplication_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  person: deserializeUpdateApplication_updateApplication_RyanWhiteApplication_person(
    serialized.person
  ),
  assignedTo:
    serialized.assignedTo != null
      ? deserializeUpdateApplication_updateApplication_RyanWhiteApplication_assignedTo(
          serialized.assignedTo
        )
      : serialized.assignedTo,
  householdMembers: serialized.householdMembers.map(
    deserializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers
  ),
  documents: serialized.documents.map(
    deserializeUpdateApplication_updateApplication_RyanWhiteApplication_documents
  ),
  documentFiles: serialized.documentFiles.map(
    deserializeUpdateApplication_updateApplication_RyanWhiteApplication_documentFiles
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeUpdateApplication_updateApplication_RyanWhiteApplication_benefitOutcomes
  ),
  accountOnDateOfService:
    serialized.accountOnDateOfService != null
      ? deserializeUpdateApplication_updateApplication_RyanWhiteApplication_accountOnDateOfService(
          serialized.accountOnDateOfService
        )
      : serialized.accountOnDateOfService,
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  receivedDate:
    serialized.receivedDate != null
      ? parseDate(serialized.receivedDate)
      : serialized.receivedDate,
  dateOfApplication:
    serialized.dateOfApplication != null
      ? parseDate(serialized.dateOfApplication)
      : serialized.dateOfApplication,
})
export const serializeUpdateApplication_updateApplication_RyanWhiteApplication = (
  deserialized: UpdateApplication_updateApplication_RyanWhiteApplication
): UpdateApplication_updateApplication_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  person: serializeUpdateApplication_updateApplication_RyanWhiteApplication_person(
    deserialized.person
  ),
  assignedTo:
    deserialized.assignedTo != null
      ? serializeUpdateApplication_updateApplication_RyanWhiteApplication_assignedTo(
          deserialized.assignedTo
        )
      : deserialized.assignedTo,
  householdMembers: deserialized.householdMembers.map(
    serializeUpdateApplication_updateApplication_RyanWhiteApplication_householdMembers
  ),
  documents: deserialized.documents.map(
    serializeUpdateApplication_updateApplication_RyanWhiteApplication_documents
  ),
  documentFiles: deserialized.documentFiles.map(
    serializeUpdateApplication_updateApplication_RyanWhiteApplication_documentFiles
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeUpdateApplication_updateApplication_RyanWhiteApplication_benefitOutcomes
  ),
  accountOnDateOfService:
    deserialized.accountOnDateOfService != null
      ? serializeUpdateApplication_updateApplication_RyanWhiteApplication_accountOnDateOfService(
          deserialized.accountOnDateOfService
        )
      : deserialized.accountOnDateOfService,
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  receivedDate:
    deserialized.receivedDate != null
      ? formatISODate(deserialized.receivedDate)
      : deserialized.receivedDate,
  dateOfApplication:
    deserialized.dateOfApplication != null
      ? formatISODate(deserialized.dateOfApplication)
      : deserialized.dateOfApplication,
})
export type UpdateApplication_updateApplication =
  | UpdateApplication_updateApplication_MedicaidApplication
  | UpdateApplication_updateApplication_MonitorApplication
  | UpdateApplication_updateApplication_CharityCareApplication
  | UpdateApplication_updateApplication_SlideApplication
  | UpdateApplication_updateApplication_RyanWhiteApplication
export const deserializeUpdateApplication_updateApplication = (
  serialized: UpdateApplication_updateApplicationOrig
): UpdateApplication_updateApplication => {
  if (false || serialized.__typename === 'MedicaidApplication')
    return deserializeUpdateApplication_updateApplication_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'MonitorApplication')
    return deserializeUpdateApplication_updateApplication_MonitorApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeUpdateApplication_updateApplication_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeUpdateApplication_updateApplication_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeUpdateApplication_updateApplication_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` + 'UpdateApplication_updateApplication'
  )
}
export const serializeUpdateApplication_updateApplication = (
  deserialized: UpdateApplication_updateApplication
): UpdateApplication_updateApplicationOrig => {
  if (false || deserialized.__typename === 'MedicaidApplication')
    return serializeUpdateApplication_updateApplication_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'MonitorApplication')
    return serializeUpdateApplication_updateApplication_MonitorApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeUpdateApplication_updateApplication_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeUpdateApplication_updateApplication_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeUpdateApplication_updateApplication_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` + 'UpdateApplication_updateApplication'
  )
}
export interface UpdateApplication {
  /**
   * Update application
   */
  updateApplication: UpdateApplication_updateApplication
}
export const deserializeUpdateApplication = (
  serialized: UpdateApplicationOrig
): UpdateApplication => ({
  ...serialized,
  updateApplication: deserializeUpdateApplication_updateApplication(
    serialized.updateApplication
  ),
})
export const serializeUpdateApplication = (
  deserialized: UpdateApplication
): UpdateApplicationOrig => ({
  ...deserialized,
  updateApplication: serializeUpdateApplication_updateApplication(
    deserialized.updateApplication
  ),
})
export interface UpdateApplicationVariables {
  application: UpdateApplicationInput
}
export const deserializeUpdateApplicationVariables = (
  serialized: UpdateApplicationVariablesOrig
): UpdateApplicationVariables => ({
  ...serialized,
  application: deserializeUpdateApplicationInput(serialized.application),
})
export const serializeUpdateApplicationVariables = (
  deserialized: UpdateApplicationVariables
): UpdateApplicationVariablesOrig => ({
  ...deserialized,
  application: serializeUpdateApplicationInput(deserialized.application),
})
